import ENUMS from '@core/classes/Enums';
import { reactive } from 'vue';

const ApplicationsSettings = reactive({
	questionList: [
		// personalInformation Section
		{
			key: 'providePrefix',
			category: 'personal',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please select your title.',
					Spanish: 'Por favor, seleccione su título.',
				},
			],
			dropdown: {
				listMethod: 'prefixList',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'isFirstNameCorrect',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.prefix',
			prevQuestion: false,
		},
		{
			key: 'isFirstNameCorrect',
			category: 'personal',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: "Is <summaryBold><summaryUpper>{namePrefilled}</summaryUpper></summaryBold> your first name on your driver's license?",
					Spanish: '¿Su nombre aparece en su licencia de conducir como <summaryBold><summaryUpper>{namePrefilled}</summaryUpper></summaryBold>?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 1,
							overrides: [
								{
									value: 'preFilledData.firstName',
									type: 'path',
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'hasMiddleName',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideFirstName',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.firstName',
			prevQuestion: true,
		},
		{
			key: 'provideFirstName',
			category: 'personal',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'validName',
						},
					],
				},
			],
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: "Please enter your first name as it appears on your driver's license.",
					Spanish: 'Por favor, ingrese su nombre como aparece en su licencia de conducir.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'hasMiddleName',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.firstName',
			prevQuestion: true,
		},
		{
			key: 'hasMiddleName',
			category: 'personal',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: "Do you have a middle name or middle name initial on your driver's license?",
					Spanish: '¿Tiene segundo nombre o inicial de segundo nombre en su licencia de conducir?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideMiddleName',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.middleName',
									override: {
										value: null,
										type: 'value',
									},
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'isLastNameCorrect',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'provideMiddleName',
			category: 'personal',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'validName',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: "Please enter your middle name as it appears on your driver's license.",
					Spanish: 'Por favor, ingrese su segundo nombre como aparece en su licencia de conducir.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'isLastNameCorrect',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.middleName',
			prevQuestion: true,
		},
		{
			key: 'isLastNameCorrect',
			category: 'personal',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: "Is <summaryBold><summaryUpper>{lastnamePrefilled}</summaryUpper></summaryBold> your last name on your driver's license?",
					Spanish: '¿Su(s) apellido(s) aparece(n) en su licencia de conducir como <summaryBold><summaryUpper>{lastnamePrefilled}</summaryUpper></summaryBold>?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 1,
							overrides: [
								{
									value: 'preFilledData.lastName',
									type: 'path',
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'hasGenerationSuffix',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideLastName',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.lastName',
			prevQuestion: true,
		},
		{
			key: 'provideLastName',
			category: 'personal',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'validName',
						},
					],
				},
			],
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: "Please enter your last name as it appears on your driver's license.",
					Spanish: 'Por favor, ingrese su(s) apellido(s) como aparece(n) en su licencia de conducir.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'hasGenerationSuffix',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.lastName',
			prevQuestion: true,
		},
		{
			key: 'hasGenerationSuffix',
			category: 'personal',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: "Do you have a generation suffix on your driver's license? (Ex: Jr, Sr, II, III, etc.)",
					Spanish: '¿Tiene sufijo de generación en su licencia de conducir? (Ej: Jr, Sr, II, III, etc.)',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'selectGenerationSuffix',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.generationSuffix',
									override: {
										value: null,
										type: 'value',
									},
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'isDateOfBirthCorrect',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'selectGenerationSuffix',
			category: 'personal',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please select your generation suffix.',
					Spanish: 'Por favor, seleccione su sufijo de generación.',
				},
			],
			dropdown: {
				listMethod: 'suffixList',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'isDateOfBirthCorrect',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.generationSuffix',
											comparisonType: 'equal',
											value: 'other',
										},
									],
									goTo: 'provideGenerationSuffix',
								},
							],
						},
						{
							action: 4,
							apiMethod: 'clearSuffixIfOther',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.generationSuffix',
			prevQuestion: true,
		},
		{
			key: 'provideGenerationSuffix',
			category: 'personal',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: "Please enter your generation suffix as it appears on your driver's license.",
					Spanish: 'Por favor, ingrese su sufijo de generación como aparece en su licencia de conducir.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'isDateOfBirthCorrect',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.generationSuffix',
			prevQuestion: true,
		},
		{
			key: 'isDateOfBirthCorrect',
			category: 'personal',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Were you born on <br><summaryBold><summaryUpper>{dateOfBirthPrefilled}</summaryUpper></summaryBold>?',
					Spanish: '¿Usted nació el <br><summaryBold><summaryUpper>{dateOfBirthPrefilled}</summaryUpper></summaryBold>?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 1,
							overrides: [
								{
									value: 'preFilledData.dateOfBirth',
									type: 'path',
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'isEmailCorrect',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'isEmailVerified',
											comparisonType: 'equal',
											value: true,
										},
									],
									goTo: 'liveInsideUS',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideDateOfBirth',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.dateOfBirth',
			prevQuestion: true,
		},
		{
			key: 'provideDateOfBirth',
			category: 'personal',
			type: 'QuestionDate',
			dateType: 'day',
			validation: [
				{
					propertyName: 'year',
					validators: [
						{
							type: 'required',
						},
					],
				},
				{
					propertyName: 'month',
					validators: [
						{
							type: 'required',
						},
					],
				},
				{
					propertyName: 'day',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your date of birth.',
					Spanish: 'Por favor, ingrese su fecha de nacimiento.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'isEmailCorrect',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'isEmailVerified',
											comparisonType: 'equal',
											value: true,
										},
									],
									goTo: 'liveInsideUS',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.dateOfBirth',
			prevQuestion: true,
		},
		{
			key: 'isEmailCorrect',
			category: 'personal',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: "Is <br><summaryBold style='word-wrap: break-word'><summaryUpper>{emailPrefilled}</summaryUpper></summaryBold> your email address?",
					Spanish:
						"¿Su dirección de correo electrónico es <br><summaryBold style='word-wrap: break-word'><summaryUpper>{emailPrefilled}</summaryUpper></summaryBold>?",
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 1,
							overrides: [
								{
									value: 'preFilledData.emailAddress',
									type: 'path',
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'liveInsideUS',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideEmail',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.emailAddress',
			prevQuestion: true,
		},
		{
			key: 'provideEmail',
			category: 'personal',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'email',
						},
					],
				},
			],
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your email address.',
					Spanish: 'Por favor, ingrese su dirección de correo electronica.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'liveInsideUS',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.emailAddress',
			prevQuestion: true,
		},
		{
			key: 'liveInsideUS',
			category: 'personal',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Do you live in the United States or a U.S. territory?',
					Spanish: '¿Vive en los Estados Unidos o en un territorio de los Estados Unidos?',
				},
			],
			notesToShow: [
				{
					conditionToShow: null,
					English: 'U.S. territory: Puerto Rico, Guam, the U.S. Virgin Islands, American Samoa, or the Northern Mariana Islands',
					Spanish:
						'Territorio de los Estados Unidos: Puerto Rico, Guam, las Islas Vírgenes de los Estados Unidos, Samoa Americana o las Islas Marianas del Norte.',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 4,
							apiMethod: 'clearAddress',
						},
						{
							action: 1,
							overrides: [
								{
									value: 'US',
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'provideUSTerritory',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 4,
							apiMethod: 'clearAddress',
						},
						{
							action: 1,
							overrides: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
											comparisonType: 'equal',
											value: 'US',
										},
									],
									value: null,
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
											comparisonType: 'different',
											value: 'US',
										},
									],
									value: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
									type: 'path',
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'provideOutsideUSCountry',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
			prevQuestion: true,
		},
		{
			key: 'provideUSTerritory',
			category: 'personal',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please select the territory you live in.',
					Spanish: 'Por favor, seleccione el territorio en el que vive.',
				},
			],
			notesToShow: [
				{
					conditionToShow: null,
					English: 'If you don’t live in a U.S. territory, select “United States.”',
					Spanish: 'Si no vive en un territorio de EE.UU., seleccione “Estados Unidos.”',
				},
			],
			dropdown: {
				listMethod: 'usTerritories',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 4,
							apiMethod: 'setUSTerritory',
						},
						{
							action: 2,
							nextQuestion: 'liveInApartment',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.usTerritory',
			prevQuestion: true,
		},
		{
			key: 'provideOutsideUSCountry',
			category: 'personal',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please select the country you live in.',
					Spanish: 'Por favor, seleccione el país en el que vive.',
				},
			],
			dropdown: {
				listMethod: 'countries',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'liveInApartment',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
			prevQuestion: true,
		},
		{
			key: 'liveInApartment',
			category: 'personal',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Do you live in an apartment, unit, or suite?',
					Spanish: '¿Vive en un apartamento, unidad o suite?',
				},
			],
			notesToShow: [
				{
					conditionToShow: null,
					English:
						"We're looking for addresses that require an 'Address Line 2' entry. If you have a unit, apartment, or suite number, select yes. If you live in a condo without a specific unit number, please select no.",
					Spanish:
						"Estamos buscando direcciones que requieren una entrada de 'Address Line 2'. Si tiene un número de unidad, apartamento o suite, seleccione sí. Si vive en un condominio sin un número de unidad específico, seleccione no.",
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideApartment',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.addressLine2',
									override: {
										value: null,
										type: 'value',
									},
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'provideZipCode',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'provideApartment',
			category: 'personal',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your apartment, unit, or suite number.',
					Spanish: 'Por favor, ingrese el número de su apartamento o condominio.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideZipCode',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.addressLine2',
			prevQuestion: true,
		},
		{
			key: 'provideZipCode',
			category: 'personal',
			type: 'QuestionInputText',
			inputType: 'tel',
			onKeyPressMethod: [
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
							comparisonType: 'equal',
							value: 'US',
						},
					],
					methodName: 'getOnkeypressNumbersOnlyFormat',
				},
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
							comparisonType: 'different',
							value: 'US',
						},
					],
					methodName: 'getOnkeypressOutsideUSZipCodeFormat',
				},
			],
			atInputMethod: [
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
							comparisonType: 'equal',
							value: 'US',
						},
					],
					methodName: 'getAtInputMethodNumbersOnlyFormat',
				},
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
							comparisonType: 'different',
							value: 'US',
						},
					],
					methodName: 'getAtInputMethodOutsideUSZipCodeFormat',
				},
			],
			validation: [
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
							comparisonType: 'equal',
							value: 'US',
						},
					],
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'validZIPUS',
						},
						{
							type: 'maxLength',
							params: [5],
						},
						{
							type: 'minLength',
							params: [5],
						},
					],
				},
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
							comparisonType: 'different',
							value: 'US',
						},
					],
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'validZIPInternational',
						},
						{
							type: 'maxLength',
							params: [10],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the zip code that you live in.',
					Spanish: 'Por favor, ingrese el código postal en el que vive.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideStreetAddress',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
											comparisonType: 'different',
											value: 'US',
										},
									],
									goTo: 'provideOutsideUSStreetAddress',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.zipCode',
			prevQuestion: true,
		},
		{
			key: 'provideStreetAddress',
			category: 'personal',
			type: 'QuestionAutoComplete',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your <summaryBold>street address</summaryBold>.',
					Spanish: 'Por favor, ingrese la <summaryBold>dirección</summaryBold> en la que vive actualmente.',
				},
			],
			notesToShow: [
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.addressLine2',
							comparisonType: 'different',
							value: null,
						},
					],
					English: 'Please do not enter your apartment, unit, or suite number here.',
					Spanish: 'Por favor, no ingrese su número de apartamento, unidad o suite aquí.',
				},
			],
			dropdown: {
				listMethod: 'addresses',
				callMethodOnChange: true,
				onSelectApiMethod: 'updateSelectedAddress',
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideCity',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.addressLine1',
			prevQuestion: true,
		},
		{
			key: 'provideOutsideUSStreetAddress',
			category: 'personal',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your street address.',
					Spanish: 'Por favor, ingrese su dirección completa, incluyendo código postal, etc.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideCity',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.addressLine1',
			prevQuestion: true,
		},
		{
			key: 'provideCity',
			category: 'personal',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'maxLength',
							params: [60],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the city or town that you live in.',
					Spanish: 'Por favor, ingrese la ciudad o el pueblo en la que vive.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideState',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.country',
											comparisonType: 'different',
											value: 'US',
										},
									],
									goTo: 'provideOutsideUSState',
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.usTerritory',
											comparisonType: 'different',
											value: 'US',
										},
									],
									goTo: 'provideCounty',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.city',
			prevQuestion: true,
		},
		{
			key: 'provideState',
			category: 'personal',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please select the state that you live in.',
					Spanish: 'Por favor, seleccione el estado en el que vive.',
				},
			],
			dropdown: {
				listMethod: 'usStatesList',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideCounty',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.state',
			prevQuestion: true,
		},
		{
			key: 'provideOutsideUSState',
			category: 'personal',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'maxLength',
							params: [60],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the state, province, or region that you live in.',
					Spanish: 'Por favor, ingrese el estado, provincia o region en el que vive.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'hasHomePhone',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.state',
			prevQuestion: true,
		},
		{
			key: 'provideCounty',
			category: 'personal',
			type: 'QuestionInputText',
			onKeyPressMethod: [
				{
					conditionToUse: null,
					methodName: 'getOnkeypressCountyFormat',
				},
			],
			atInputMethod: [
				{
					conditionToUse: null,
					methodName: 'getAtInputMethodCountyFormat',
				},
			],
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'maxLength',
							params: [60],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the county that you live in.',
					Spanish: 'Por favor, ingrese el condado en el que vive.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'hasHomePhone',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.county',
			prevQuestion: true,
		},
		{
			key: 'hasHomePhone',
			category: 'personal',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Do you have a home phone?',
					Spanish: '¿Tiene teléfono en la casa?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideHomePhoneNumber',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'personalSummary',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'provideHomePhoneNumber',
			category: 'personal',
			type: 'QuestionInputPhone',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'maxLength',
							params: [10],
						},
						{
							type: 'minLength',
							params: [10],
						},
						{
							type: 'numeric',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your home phone number.',
					Spanish: 'Por favor, ingrese el número de teléfono de su casa.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'personalSummary',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.homePhoneNumber',
			prevQuestion: true,
		},
		{
			key: 'personalSummary',
			category: 'personal',
			type: 'QuestionSummary',
			triggerSave: true,
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: "Please review all the information below and confirm if it is correct and matches your driver's license or identification.",
					Spanish: 'Por favor, revise toda la siguiente información y confirme si esta correcta y coincide con su licensia de conducir o indentificacíon.',
				},
				//NOTE: Full Name (without generation suffix)
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.generationSuffix',
							comparisonType: 'equal',
							value: null,
						},
					],
					English: ["<p class='summaryList'> Full Name: <summaryBold> {provideFirstName} {provideMiddleName} {provideLastName} </summaryBold></p>"].join(''),
					Spanish: ["<p class='summaryList'> Nombre Completo: <summaryBold> {provideFirstName} {provideMiddleName} {provideLastName} </summaryBold></p>"].join(
						'',
					),
				},
				//NOTE: Full Name (with generation suffix)
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.generationSuffix',
							comparisonType: 'different',
							value: null,
						},
					],
					English: [
						"<p class='summaryList'> Full Name: <summaryBold> {provideFirstName} {provideMiddleName} {provideLastName} {provideGenerationSuffix} </summaryBold></p>",
					].join(''),
					Spanish: [
						"<p class='summaryList'> Nombre Completo: <summaryBold> {provideFirstName} {provideMiddleName} {provideLastName} {provideGenerationSuffix} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Date of Birth, Current Residence Title
				{
					conditionToShow: null,
					English: ["<p class='summaryList'> Date of birth: <summaryBold> {provideDateOfBirth} </summaryBold></p>", '<br>Current Residence:'].join(''),
					Spanish: ["<p class='summaryList'> Fecha de nacimiento: <summaryBold> {provideDateOfBirth} </summaryBold></p>", '<br>Residencia Actual:'].join(''),
				},
				//NOTE: US Address without address line 2
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideStreetAddress',
							dataPathType: 'array',
						},
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.addressLine2',
							comparisonType: 'equal',
							value: null,
						},
					],
					English: [
						//Address
						"<p class='summaryList'> Address: <summaryBold> {provideStreetAddress} </summaryBold></p>",
						//Apartment
						"<p class='summaryList'> Apt/Unit/Suite: <summaryBold> None </summaryBold></p>",
						//City
						"<p class='summaryList'> City: <summaryBold> {provideCity} </summaryBold></p>",
						//State
						"<p class='summaryList'> State: <summaryBold> {provideState} </summaryBold></p>",
						//Zip Code
						"<p class='summaryList'> Zip Code: <summaryBold> {provideZipCode} </summaryBold></p>",
						//County
						"<p class='summaryList'> County: <summaryBold> {provideCounty} </summaryBold></p>",
					].join(''),
					Spanish: [
						//Address
						"<p class='summaryList'> Direccíon: <summaryBold> {provideStreetAddress} </summaryBold></p>",
						//Apartment
						"<p class='summaryList'> Apto/Unidad/Suite: <summaryBold> Ninguno </summaryBold></p>",
						//City
						"<p class='summaryList'> Ciudad: <summaryBold> {provideCity} </summaryBold></p>",
						//State
						"<p class='summaryList'> Estado: <summaryBold> {provideState} </summaryBold></p>",
						//Zip Code
						"<p class='summaryList'> Código Postal: <summaryBold> {provideZipCode} </summaryBold></p>",
						//County
						"<p class='summaryList'> Condado: <summaryBold> {provideCounty} </summaryBold></p>",
					].join(''),
				},
				//NOTE: US Address with address line 2
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideStreetAddress',
							dataPathType: 'array',
						},
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.addressLine2',
							comparisonType: 'different',
							value: null,
						},
					],
					English: [
						//Address
						"<p class='summaryList'> Address: <summaryBold> {provideStreetAddress} </summaryBold></p>",
						//Apartment
						"<p class='summaryList'> Apt/Unit/Suite: <summaryBold> {provideApartment} </summaryBold></p>",
						//City
						"<p class='summaryList'> City: <summaryBold> {provideCity} </summaryBold></p>",
						//State
						"<p class='summaryList'> State: <summaryBold> {provideState} </summaryBold></p>",
						//Zip Code
						"<p class='summaryList'> Zip Code: <summaryBold> {provideZipCode} </summaryBold></p>",
						//County
						"<p class='summaryList'> County: <summaryBold> {provideCounty} </summaryBold></p>",
					].join(''),
					Spanish: [
						//Address
						"<p class='summaryList'> Direccíon: <summaryBold> {provideStreetAddress} </summaryBold></p>",
						//Apartment
						"<p class='summaryList'> Apto/Unidad/Suite: <summaryBold> {provideApartment} </summaryBold></p>",
						//City
						"<p class='summaryList'> Ciudad: <summaryBold> {provideCity} </summaryBold></p>",
						//State
						"<p class='summaryList'> Estado: <summaryBold> {provideState} </summaryBold></p>",
						//Zip Code
						"<p class='summaryList'> Código Postal: <summaryBold> {provideZipCode} </summaryBold></p>",
						//County
						"<p class='summaryList'> Condado: <summaryBold> {provideCounty} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Outside US Address without address line 2
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideOutsideUSCountry',
							dataPathType: 'array',
						},
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.addressLine2',
							comparisonType: 'equal',
							value: null,
						},
					],
					English: [
						//Address
						"<p class='summaryList'> Address: <summaryBold> {provideStreetAddress} </summaryBold></p>",
						//Apartment
						"<p class='summaryList'> Apt/Unit/Suite: <summaryBold> None </summaryUpper</p>",
						//City
						"<p class='summaryList'> City: <summaryBold> {provideCity} </summaryBold></p>",
						//State
						"<p class='summaryList'> State: <summaryBold> {provideState} </summaryBold></p>",
						//Zip Code
						"<p class='summaryList'> Zip Code: <summaryBold> {provideZipCode} </summaryBold></p>",
						//County
						"<p class='summaryList'> County: <summaryBold> {provideCounty} </summaryBold></p>",
					].join(''),
					Spanish: [
						//Address
						"<p class='summaryList'> Direccíon: <summaryBold> {provideStreetAddress} </summaryBold></p>",
						//Apartment
						"<p class='summaryList'> Apto/Unidad/Suite: <summaryBold> Ninguno </summaryUpper</p>",
						//City
						"<p class='summaryList'> Ciudad: <summaryBold> {provideCity} </summaryBold></p>",
						//State
						"<p class='summaryList'> Estado: <summaryBold> {provideState} </summaryBold></p>",
						//Zip Code
						"<p class='summaryList'> Código Postal: <summaryBold> {provideZipCode} </summaryBold></p>",
						//County
						"<p class='summaryList'> Condado: <summaryBold> {provideCounty} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Outside US Address with address line 2
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideOutsideUSCountry',
							dataPathType: 'array',
						},
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.addressLine2',
							comparisonType: 'different',
							value: null,
						},
					],
					English: [
						//Address
						"<p class='summaryList'> Address: <summaryBold> {provideOutsideUSStreetAddress} </summaryBold></p>",
						//Apartment
						"<p class='summaryList'> Apt/Unit/Suite: <summaryBold> {provideApartment} </summaryBold></p>",
						//City
						"<p class='summaryList'> City: <summaryBold> {provideCity} </summaryBold></p>",
						//State
						"<p class='summaryList'> State: <summaryBold> {provideOutsideUSState} </summaryBold></p>",
						//Zip Code
						"<p class='summaryList'> Zip Code: <summaryBold> {provideZipCode} </summaryBold></p>",
						//Country
						"<p class='summaryList'> Country: <summaryBold> {provideOutsideUSCountry} </summaryBold></p>",
					].join(''),
					Spanish: [
						//Address
						"<p class='summaryList'> Direccíon : <summaryBold> {provideOutsideUSStreetAddress} </summaryBold></p>",
						//Apartment
						"<p class='summaryList'> Apto/Unidad/Suite: <summaryBold> {provideApartment} </summaryBold></p>",
						//City
						"<p class='summaryList'> Ciudad: <summaryBold> {provideCity} </summaryBold></p>",
						//State
						"<p class='summaryList'> Estado: <summaryBold> {provideOutsideUSState} </summaryBold></p>",
						//Zip Code
						"<p class='summaryList'> Código Postal: <summaryBold> {provideZipCode} </summaryBold></p>",
						//Country
						"<p class='summaryList'> País: <summaryBold> {provideOutsideUSCountry} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Home Phone Number
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideHomePhoneNumber',
							dataPathType: 'array',
						},
					],
					English: 'Home Phone Number: <summaryBold> {provideHomePhoneNumber} </summaryBold>',
					Spanish: 'Número de Teléfono del Hogar: <summaryBold> {provideHomePhoneNumber} </summaryBold>',
				},
			],
			answerButtons: [
				{
					label: 'yesSummary',
					actions: [
						{
							action: 2,
							nextQuestion: 'thankYouMessage',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'dateCompleted',
											comparisonType: 'different',
											value: null,
										},
									],
									goTo: 'applicationUpdatedPersonal',
								},
							],
						},
						{
							action: 5,
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'noSummary',
					actions: [
						{
							action: 2,
							nextQuestion: 'providePrefix',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
			// redirectToCustomerPortal: true,
		},
		////Plaid Question
		//{ //Plaid code
		//    key: 'cashTransaction
		//    category: 'quote',
		//    type: 'QuestionPlaidLink',
		//    isEndOfApp: true,
		//    summaryDisplay: false,
		//    textsToShow: [
		//        {
		//            conditionToShow: null,
		//            English: "Almost there! To protect against fraud and ensure your identity is secure, we kindly ask you to take a photo of your driver's license. This step helps us confirm your identity and speed up the application process. It's just like showing your ID, but in a digital format. Rest assured, your information is securely stored and only used for the purpose of this application.",
		//            Spanish: "Casi hemos terminado! Para proteger contra el fraude y asegurar que su identidad esté segura, le pedimos amablemente que tome una foto de su licencia de conducir. Este paso nos ayuda a confirmar su identidad y acelerar el proceso de la solicitud. Es como mostrar su identificación, pero en formato digital. Tenga la seguridad de que su información se almacena de manera segura y solo se utiliza para el propósito de esta solicitud."
		//        },
		//    ],
		//    answerButtons: [
		//        //{
		//        //    label: 'procedeWithoutPlaidLink',
		//        //    actions: [
		//        //        {
		//        //            action: 2,
		//        //            nextQuestion: 'thankYouMessage',
		//        //        }
		//        //    ],
		//        //    style: {
		//        //        background: 'successButtonColor',
		//        //        text: 'successButtonTextColor'
		//        //    }
		//        //},
		//        {
		//            label: 'continue',
		//            isValidationRequired: true,
		//            actions: [
		//                {
		//                    action: 4,
		//                    apiMethod: 'plaidInfo'
		//                },
		//                {
		//                    action: 2,
		//                    nextQuestion: 'thankYouMessage',
		//                }
		//            ],
		//            style: {
		//                background: 'successButtonColor',
		//                text: 'successButtonTextColor'
		//            }
		//        }
		//    ],
		//    savedAnswer: null,
		//    dataStructurePath: '',
		//    prevQuestion: true,
		//},
		{
			key: 'provideEstimateCreditScore',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please select your estimated credit score.',
					Spanish: 'Por favor seleccione su puntuación de crédito estimada.',
				},
			],
			dropdown: {
				listMethod: 'estimatedCreditScore',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'wantAccureQuoteSSN',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.estimateCreditScore',
			prevQuestion: true,
			isFirstInGroup: true,
		},
		{
			key: 'wantAccureQuoteSSN',
			category: 'creditApp',
			type: 'QuestionSocial',
			mask: 'XXX-XX-XXXX',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'maxLength',
							params: [9],
						},
						{
							type: 'minLength',
							params: [9],
						},
						{
							type: 'numeric',
						},
					],
				},
			],
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your Social Security Number.',
					Spanish: 'Por favor ingrese su Número de Seguro Social',
				},
			],
			answerButtons: [
				//{
				//    label: 'getEstimatedQuotePerson',
				//    actions: [
				//        {
				//            action: 1,
				//            overrides: [
				//                {
				//                    value: null
				//                }
				//            ],
				//        },
				//        //{
				//        //    action: 4,
				//        //    apiMethod: 'checkCredit'
				//        //},
				//        {
				//            action: 2,
				//            nextQuestion: 'quoteSummary'
				//        },
				//        {
				//            action: 3,
				//            extraValuesToSave: [
				//                {
				//                    type: "value",
				//                    savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.ssnHashed'
				//                },
				//                {
				//                    type: "value",
				//                    savePath: 'quoteAppData.applicationsDataAnswered.requestedInaccurateQuote',
				//                    override: {
				//                        value: true,
				//                        type: 'value'
				//                    }
				//                },
				//            ],
				//        }
				//    ],
				//    style: {
				//        background: 'successButtonColor',
				//        text: 'successButtonTextColor'
				//    }
				//},
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						//{
						//    action: 4,
						//    apiMethod: 'checkCredit'
						//},
						{
							action: 4,
							apiMethod: 'encryptSsn',
						},
						{
							action: 5,
							conditionsToSave: [
								{
									dataPath: 'dateCompleted',
									comparisonType: 'different',
									value: null,
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'provideMovedInDate',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.ssnLast4',
			prevQuestion: true,
		},

		// **** Residence Related ****
		{
			key: 'provideMovedInDate',
			category: 'creditApp',
			type: 'QuestionDate',
			dateType: 'month',
			validation: [
				{
					propertyName: 'year',
					validators: [
						{
							type: 'required',
						},
					],
				},
				{
					propertyName: 'month',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideStreetAddress',
							dataPathType: 'array',
						},
					],
					English:
						'When did you move to <summaryBold><summaryUpper>{provideStreetAddress} {provideApartment}, {provideCity}, {provideState} {provideZipCode}, {provideCounty}</summaryUpper></summaryBold>?',
					Spanish:
						'¿Cuándo se mudó a <summaryBold><summaryUpper>{provideStreetAddress} {provideApartment}, {provideCity}, {provideState} {provideZipCode}, {provideCounty}</summaryUpper></summaryBold>?',
				},
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideOutsideUSCountry',
							dataPathType: 'array',
						},
					],
					English:
						'When did you move to <summaryBold><summaryUpper>{provideOutsideUSStreetAddress} {provideApartment}, {provideCity}, {provideOutsideUSState} {provideZipCode}, {provideOutsideUSCountry}</summaryUpper></summaryBold>?',
					Spanish:
						'¿Cuándo se mudó a <summaryBold><summaryUpper>{provideOutsideUSStreetAddress} {provideApartment}, {provideCity}, {provideOutsideUSState} {provideZipCode}, {provideOutsideUSCountry}</summaryUpper></summaryBold>?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'selectResidentStatus',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate',
			prevQuestion: true,
			isFirstInGroup: true,
		},
		{
			key: 'selectResidentStatus',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Your current residence status at your current address is:',
					Spanish: 'Su estatus actual de residencia en su dirección actual es:',
				},
			],
			dropdown: {
				listMethod: 'residenceOwnershipStatus',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'creditAppSummary1',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.status',
											comparisonType: 'equal',
											value: 'mortgage',
										},
									],
									goTo: 'provideMortgageMonthlyPayment',
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.status',
											comparisonType: 'equal',
											value: 'rental',
										},
									],
									goTo: 'provideRentalMonthlyPayment',
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.status',
											comparisonType: 'equal',
											value: 'own',
										},
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate', // provideMovedInDate
											comparisonType: 'less',
											value: '24',
											dataPathType: 'date',
										},
									],
									goTo: 'liveInsideUSPreviously',
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.status',
											comparisonType: 'equal',
											value: 'familyOther',
										},
									],
									goTo: 'withWhomYouLive',
								},
							],
						},
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesInsurance',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesTax',
									override: {
										value: null,
										type: 'value',
									},
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.status',
			prevQuestion: true,
		},
		{
			key: 'provideMortgageMonthlyPayment',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your monthly payment amount.',
					Spanish: 'Por favor ingrese el monto de su pago mensual',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'AreInsurenceOrTaxesIncluded',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentAmount',
			prevQuestion: true,
		},
		{
			key: 'AreInsurenceOrTaxesIncluded',
			category: 'creditApp',
			type: 'QuestionMultiButtons',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English:
						'Does your monthly payment of <summaryBold><summaryUpper>{provideMortgageMonthlyPayment}</summaryUpper></summaryBold> include escrow for Insurance and/or Taxes?',
					Spanish:
						'¿Su pado mensual de <summaryBold><summaryUpper>{provideMortgageMonthlyPayment}</summaryUpper></summaryBold> incluye el seguro y/o los impuestos sobre la propiedad?',
				},
			],
			answerButtons: [
				{
					label: 'both',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideInsurenceFrequency',
						},
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesInsurance',
									override: {
										value: true,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesTax',
									override: {
										value: true,
										type: 'value',
									},
								},
							],
						},
					],
					style: {
						background: 'optionsButtonColor',
						text: 'optionsButtonTextColor',
					},
				},
				{
					label: 'neither', //was 'no' before checking for potencial issues
					actions: [
						{
							action: 2,
							nextQuestion: 'liveInsideUSPreviously',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate', // provideMovedInDate
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],
									goTo: 'creditAppSummary1',
								},
							],
						},
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesInsurance',
									override: {
										value: false,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesTax',
									override: {
										value: false,
										type: 'value',
									},
								},
							],
						},
					],
					style: {
						background: 'optionsButtonColor',
						text: 'optionsButtonTextColor',
					},
				},
				{
					label: 'insurance',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideInsurenceFrequency',
						},
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesInsurance',
									override: {
										value: true,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesTax',
									override: {
										value: false,
										type: 'value',
									},
								},
							],
						},
					],
					style: {
						background: 'optionsButtonColor',
						text: 'optionsButtonTextColor',
					},
				},
				{
					label: 'taxes',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideTaxFrequency',
						},
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesInsurance',
									override: {
										value: false,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesTax',
									override: {
										value: true,
										type: 'value',
									},
								},
							],
						},
					],
					style: {
						background: 'optionsButtonColor',
						text: 'optionsButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'provideInsurenceFrequency',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How often do you pay the insurance?',
					Spanish: '¿Con qué frecuencia paga el seguro?',
				},
			],
			dropdown: {
				listMethod: 'monthlyAndAnnuallyFrequencies',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideInsurenceAmount',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.insuranceFrequency',
			prevQuestion: true,
		},
		{
			key: 'provideInsurenceAmount',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter approximately the insurance amount you pay {provideInsurenceFrequency}.',
					Spanish: 'Por favor ingrese el monto {provideInsurenceFrequency} que paga de seguro aproximadamente.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'liveInsideUSPreviously',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentIncludesTax',
											comparisonType: 'equal',
											value: true,
										},
									],
									goTo: 'provideTaxFrequency',
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate', // provideMovedInDate
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],
									goTo: 'creditAppSummary1',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.insuranceAmount',
			prevQuestion: true,
		},
		{
			key: 'provideTaxFrequency',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How often do you pay the property taxes?',
					Spanish: '¿Con qué frecuencia paga los impuestos sobre la propiedad?',
				},
			],
			dropdown: {
				listMethod: 'monthlyAndAnnuallyFrequencies',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideTaxAmount',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.taxFrequency',
			prevQuestion: true,
		},
		{
			key: 'provideTaxAmount',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter approximately the property taxes amount you pay {provideTaxFrequency}.',
					Spanish: 'Por favor ingrese el monto {provideTaxFrequency} que paga de impuestos sobre la propiedad aproximadamente.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'liveInsideUSPreviously',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate', // provideMovedInDate
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],
									goTo: 'creditAppSummary1',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.taxAmount',
			prevQuestion: true,
		},
		{
			key: 'provideRentalMonthlyPayment',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your monthly payment amount.',
					Spanish: 'Por favor ingrese el monto de su pago mensual',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'liveInsideUSPreviously',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate', // provideMovedInDate
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],
									goTo: 'creditAppSummary1',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentAmount',
			prevQuestion: true,
		},
		{
			key: 'withWhomYouLive',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'With whom do you live?',
					Spanish: '¿Con quién usted vive?',
				},
			],
			dropdown: {
				listMethod: 'liveWithFamily',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideMonthlyPayment',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.sharedWith',
											comparisonType: 'equal',
											value: 'other',
										},
									],
									goTo: 'provideWithWhomYouLive',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.sharedWith',
			prevQuestion: true,
		},
		{
			key: 'provideWithWhomYouLive',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please explain your living situation.',
					Spanish: 'Por favor explique su situación de vivienda',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideMonthlyPayment',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.sharedWith',
			prevQuestion: true,
		},
		{
			key: 'provideMonthlyPayment',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [0],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your monthly payment amount.',
					Spanish: 'Por favor ingrese el monto de su pago mensual',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'liveInsideUSPreviously',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate', // provideMovedInDate
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],
									goTo: 'creditAppSummary1',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.paymentAmount',
			prevQuestion: true,
		},
		{
			key: 'liveInsideUSPreviously',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Was your previous address in the United States or a U.S. territory?',
					Spanish: '¿Su dirección anterior fue en los Estados Unidos o en un territorio de los Estados Unidos?',
				},
			],
			notesToShow: [
				{
					conditionToShow: null,
					English: 'U.S. territory: Puerto Rico, Guam, the U.S. Virgin Islands, American Samoa, or the Northern Mariana Islands',
					Spanish:
						'Territorio de los Estados Unidos: Puerto Rico, Guam, las Islas Vírgenes de los Estados Unidos, Samoa Americana o las Islas Marianas del Norte.',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 4,
							apiMethod: 'clearAddress',
						},
						{
							action: 1,
							overrides: [
								{
									value: 'US',
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'providePreviousUSTerritory',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 4,
							apiMethod: 'clearAddress',
						},
						{
							action: 1,
							overrides: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
											comparisonType: 'equal',
											value: 'US',
										},
									],
									value: null,
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
											comparisonType: 'different',
											value: 'US',
										},
									],
									value: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
									type: 'path',
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'providePreviousOutsideUSCountry',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
			prevQuestion: true,
		},
		{
			key: 'providePreviousUSTerritory',
			category: 'personal',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please select the territory you previously lived in.',
					Spanish: 'Por favor, seleccione el territorio en el que vivía anteriormente.',
				},
			],
			notesToShow: [
				{
					conditionToShow: null,
					English: 'If you didn’t live in a U.S. territory, select “United States.”',
					Spanish: 'Si no vivía en un territorio de EE.UU., seleccione “Estados Unidos.”',
				},
			],
			dropdown: {
				listMethod: 'usTerritories',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 4,
							apiMethod: 'setUSTerritory',
						},
						{
							action: 2,
							nextQuestion: 'liveInApartmentPreviously',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.usTerritory',
			prevQuestion: true,
		},
		{
			key: 'providePreviousOutsideUSCountry',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please select the country you previously lived in.',
					Spanish: 'Por favor seleccione el país en el que vivío anteriormente.',
				},
			],
			dropdown: {
				listMethod: 'countries',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'liveInApartmentPreviously',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
			prevQuestion: true,
		},
		{
			key: 'liveInApartmentPreviously',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Did you previously live in an apartment, unit, or suite?',
					Spanish: '¿Anteriormente, vivió en un apartamento o condominio?',
				},
			],
			notesToShow: [
				{
					conditionToShow: null,
					English:
						"We're looking for addresses that require an 'Address Line 2' entry. If you have a unit, apartment, or suite number, select yes. If you live in a condo without a specific unit number, please select no.",
					Spanish:
						"Estamos buscando direcciones que requieren una entrada de 'Address Line 2'. Si tiene un número de unidad, apartamento o suite, seleccione sí. Si vive en un condominio sin un número de unidad específico, seleccione no.",
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'providePreviousApartment',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'providePreviousZipCode',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'providePreviousApartment',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the previous apartment, unit, or suite number.',
					Spanish: 'Por favor ingrese el número anterior del apartamento o condominio.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousZipCode',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.addressLine2',
			prevQuestion: true,
		},
		{
			key: 'providePreviousZipCode',
			category: 'creditApp',
			type: 'QuestionInputText',
			inputType: 'tel',
			onKeyPressMethod: [
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
							comparisonType: 'equal',
							value: 'US',
						},
					],
					methodName: 'getOnkeypressNumbersOnlyFormat',
				},
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
							comparisonType: 'different',
							value: 'US',
						},
					],
					methodName: 'getOnkeypressOutsideUSZipCodeFormat',
				},
			],
			atInputMethod: [
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
							comparisonType: 'equal',
							value: 'US',
						},
					],
					methodName: 'getAtInputMethodNumbersOnlyFormat',
				},
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
							comparisonType: 'different',
							value: 'US',
						},
					],
					methodName: 'getAtInputMethodOutsideUSZipCodeFormat',
				},
			],
			validation: [
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
							comparisonType: 'equal',
							value: 'US',
						},
					],
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'validZIPUS',
						},
						{
							type: 'maxLength',
							params: [5],
						},
						{
							type: 'minLength',
							params: [5],
						},
					],
				},
				{
					conditionToUse: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
							comparisonType: 'different',
							value: 'US',
						},
					],
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'validZIPInternational',
						},
						{
							type: 'maxLength',
							params: [10],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the previous zip code.',
					Spanish: 'Por favor ingrese el código postal anterior.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousStreetAddress',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
											comparisonType: 'different',
											value: 'US',
										},
									],
									goTo: 'providePreviousOutsideUSStreetAddress',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.zipCode',
			prevQuestion: true,
		},
		{
			key: 'providePreviousStreetAddress',
			category: 'creditApp',
			type: 'QuestionAutoComplete',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter your previous street address.',
					Spanish: 'Por favor ingrese su dirección anterior.',
				},
			],
			dropdown: {
				listMethod: 'addresses',
				callMethodOnChange: true,
				onSelectApiMethod: 'updateSelectedAddress',
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousCity',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.addressLine1',
			prevQuestion: true,
		},
		{
			key: 'providePreviousOutsideUSStreetAddress',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the street previous address.',
					Spanish: 'Por ingrese su dirección anterior.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousCity',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.addressLine1',
			prevQuestion: true,
		},
		{
			key: 'providePreviousCity',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the city or town.',
					Spanish: 'Por favor ingrese la ciudad o el pueblo.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousState',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.country',
											comparisonType: 'different',
											value: 'US',
										},
									],
									goTo: 'providePreviousOutsideUSState',
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.usTerritory',
											comparisonType: 'different',
											value: 'US',
										},
									],
									goTo: 'providePreviousCounty',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.city',
			prevQuestion: true,
		},
		{
			key: 'providePreviousState',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please select the previous state.',
					Spanish: 'Por favor selecione el estado anterior.',
				},
			],
			dropdown: {
				listMethod: 'usStatesList',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousCounty',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.state',
			prevQuestion: true,
		},
		{
			key: 'providePreviousOutsideUSState',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'maxLength',
							params: [60],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the previous state, province, or region.',
					Spanish: 'Por favor ingrese el estado, provincia o region anterior.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousMovedInDate',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.state',
			prevQuestion: true,
		},
		{
			key: 'providePreviousCounty',
			category: 'creditApp',
			type: 'QuestionInputText',
			onKeyPressMethod: [
				{
					conditionToUse: null,
					methodName: 'getOnkeypressCountyFormat',
				},
			],
			atInputMethod: [
				{
					conditionToUse: null,
					methodName: 'getAtInputMethodCountyFormat',
				},
			],
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the previous county.',
					Spanish: 'Por favor ingrese el condado anterior.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousMovedInDate',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.county',
			prevQuestion: true,
		},
		{
			key: 'providePreviousMovedInDate',
			category: 'creditApp',
			type: 'QuestionDate',
			dateType: 'month',
			validation: [
				{
					propertyName: 'year',
					validators: [
						{
							type: 'required',
						},
					],
				},
				{
					propertyName: 'month',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'When did you move to the previous address?',
					Spanish: '¿Cuando se mudó a la dirección anterior?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'creditAppSummary1',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.movedInDate',
			prevQuestion: true,
		},
		{
			key: 'creditAppSummary1',
			category: 'creditApp',
			type: 'QuestionSummary',
			triggerSave: true,
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please review all the information below and confirm if it is correct.',
					Spanish: 'Por favor, revise toda la siguiente información y confirme si esta correcta.',
				},
				//NOTE: Estimated Credit Score, Social Security Number, Housing Information Title
				{
					conditionToShow: null,
					English: [
						'Estimated Credit Score: <summaryBold>{provideEstimateCreditScore}</summaryBold>',
						"<p class='summaryList'> Social Security Number: <summaryBold> {wantAccureQuoteSSN} </summaryBold></p>",
						'</br> Housing Information:',
					].join(''),
					Spanish: [
						'Puntuación de Crédito Estimada: <summaryBold> {provideEstimateCreditScore} </summaryBold>',
						"<p class='summaryList'>Número de Seguro Social: <summaryBold>{wantAccureQuoteSSN} </summaryBold></p>",
						'</br> Información de vivienda:',
					].join(''),
				},
				//NOTE: Tax Amount and Frequency
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideTaxAmount',
							dataPathType: 'array',
						},
					],
					English: [
						"<p class='summaryList'> Property Taxes: <summaryBold> {provideTaxAmount} {provideTaxFrequency} </summaryBold> (included in mortgage)</p>",
					].join(''),
					Spanish: [
						"<p class='summaryList'> Impuestos sobre la Propiedad: <summaryBold> {provideTaxAmount} {provideTaxFrequency} </summaryBold> (incluido en la hipoteca)</p>",
					].join(''),
				},
				//NOTE: Insurance Amount and Frequency
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideInsurenceAmount',
							dataPathType: 'array',
						},
					],
					English: [
						"<p class='summaryList'>Insurance: <summaryBold> {provideInsurenceAmount} {provideInsurenceFrequency} </summaryBold> (included in mortgage)</p>",
					].join(''),
					Spanish: [
						"<p class='summaryList'>Seguro: <summaryBold> {provideInsurenceAmount} {provideInsurenceFrequency} </summaryBold> (incluido en la hipoteca)</p>",
					].join(''),
				},
				//NOTE: Mortgage Monthly Payment
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideMortgageMonthlyPayment',
							dataPathType: 'array',
						},
					],
					English: [
						"<p class='summaryList'> Total {selectResidentStatus} Payment: <summaryBold> {provideMortgageMonthlyPayment} Monthly </summaryBold></p>",
					].join(''),
					Spanish: [
						"<p class='summaryList'> Pago Total de {selectResidentStatus}: <summaryBold> {provideMortgageMonthlyPayment} Mensual </summaryBold></p>",
					].join(''),
				},
				//NOTE: Rental Monthly Payment
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideRentalMonthlyPayment',
							dataPathType: 'array',
						},
					],
					English: ["<p class='summaryList'> {selectResidentStatus}: <summaryBold> {provideRentalMonthlyPayment} Monthly</summaryBold></p>"].join(''),
					Spanish: ["<p class='summaryList'>{selectResidentStatus}: <summaryBold> {provideRentalMonthlyPayment} Mensual </summaryBold></p>"].join(''),
				},
				//NOTE: Own Monthly Payment
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.residenceStatus.status',
							comparisonType: 'equal',
							value: 'own',
						},
					],
					English: ["<p class='summaryList'> {selectResidentStatus}: <summaryBold> $0.00 </summaryBold></p>"].join(''),
					Spanish: ["<p class='summaryList'> {selectResidentStatus}: <summaryBold> $0.00 </summaryBold></p>"].join(''),
				},
				//NOTE: Other Monthly Payment
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideMonthlyPayment',
							dataPathType: 'array',
						},
					],
					English: [
						"<p class='summaryList'> Description: Living with <summaryBold> {withWhomYouLive} </summaryBold></p>",
						"<p class='summaryList'> Monthly Payment: <summaryBold> {provideMonthlyPayment} </summaryBold></p>",
					].join(''),
					Spanish: [
						"<p class='summaryList'> Descripción: Vivo con mi <summaryBold><summaryUpper> {withWhomYouLive} </summaryUpper></summaryBold></p>",
						"<p class='summaryList'> Pago mensual: <summaryBold> {provideMonthlyPayment} </summaryBold></p>",
					].join(''),
				},
				{
					conditionToShow: null,
					English: ["<p class='summaryList'> Moved in Date: <summaryBold> {provideMovedInDate} </summaryBold></p>"].join(''),
					Spanish: ["<p class='summaryList'> Fecha de Mudanza: <summaryBold> {provideMovedInDate} </summaryBold></p>"].join(''),
				},

				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate',
							comparisonType: 'lessOrEqual',
							value: '24',
							dataPathType: 'date',
						},
					],
					English: ['<br>Previous Address:'].join(''),
					Spanish: ['<br>Dirección Anterior:'].join(''),
				},
				//NOTE: If the previous address does not have an apartment, then the apartment will be none
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.addressLine2',
							comparisonType: 'equal',
							value: null,
						},
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'providePreviousMovedInDate',
							dataPathType: 'array',
						},
					],
					English: [
						// Street Address
						"<p class='summaryList'> Street Address: <summaryBold> {providePreviousStreetAddress} </summaryBold></p>",
						// Apartment
						"<p class='summaryList'> Apt/Unit/Suite: <summaryBold> none </summaryBold></p>",
						// City
						"<p class='summaryList'> City: <summaryBold> {providePreviousCity} </summaryBold></p>",
						// State
						"<p class='summaryList'> State/Territory: <summaryBold> {providePreviousState} </summaryBold></p>",
						// Zip Code
						"<p class='summaryList'> Zip Code: <summaryBold> {providePreviousZipCode} </summaryBold></p>",
						// County
						"<p class='summaryList'> County: <summaryBold> {providePreviousCounty} </summaryBold></p>",
					].join(''),
					Spanish: [
						// Street Address
						"<p class='summaryList'> Dirección: <summaryBold> {providePreviousStreetAddress} </summaryBold></p>",
						// Apartment
						"<p class='summaryList'> Apto/Unidad/Suite: <summaryBold> none </summaryBold></p>",
						// City
						"<p class='summaryList'> Ciudad: <summaryBold> {providePreviousCity} </summaryBold></p>",
						// State
						"<p class='summaryList'> Estado/Territorio: <summaryBold> {providePreviousState} </summaryBold></p>",
						// Zip Code
						"<p class='summaryList'> Código Postal: <summaryBold> {providePreviousZipCode} </summaryBold></p>",
						// County
						"<p class='summaryList'> Condado: <summaryBold> {providePreviousCounty} </summaryBold></p>",
					].join(''),
				},
				//NOTE: else If the previous address has an apartment, then the apartment will be the previous apartment #
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.addressLine2',
							comparisonType: 'different',
							value: null,
						},
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'providePreviousStreetAddress',
							dataPathType: 'array',
						},
					],
					English: [
						// Street Address
						"<p class='summaryList'> Street Address: <summaryBold> {providePreviousStreetAddress} </summaryBold></p>",
						// Apartment
						"<p class='summaryList'> Apt/Unit/Suite: <summaryBold> {providePreviousApartment} </summaryBold></p>",
						// City
						"<p class='summaryList'> City: <summaryBold> {providePreviousCity} </summaryBold></p>",
						// State
						"<p class='summaryList'> State/Territory: <summaryBold> {providePreviousState} </summaryBold></p>",
						// Zip Code
						"<p class='summaryList'> Zip Code: <summaryBold> {providePreviousZipCode} </summaryBold></p>",
						// County
						"<p class='summaryList'> County: <summaryBold> {providePreviousCounty} </summaryBold></p>",
					].join(''),
					Spanish: [
						// Street Address
						"<p class='summaryList'> Dirección: <summaryBold> {providePreviousStreetAddress} </summaryBold></p>",
						// Apartment
						"<p class='summaryList'> Apto/Unidad/Suite: <summaryBold> {providePreviousApartment} </summaryBold></p>",
						// City
						"<p class='summaryList'> Ciudad: <summaryBold> {providePreviousCity} </summaryBold></p>",
						// State
						"<p class='summaryList'> Estado/Territorio: <summaryBold> {providePreviousState} </summaryBold></p>",
						// Zip Code
						"<p class='summaryList'> Código Postal: <summaryBold> {providePreviousZipCode} </summaryBold></p>",
						// Condado
						"<p class='summaryList'> Condado: <summaryBold> {providePreviousCounty} </summaryBold></p>",
					].join(''),
				},
				//NOTE: If the previous Outside US address does NOT have an apartment, then the apartment will be N/A
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.addressLine2',
							comparisonType: 'equal',
							value: null,
						},
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'providePreviousOutsideUSCountry',
							dataPathType: 'array',
						},
					],
					English: [
						// Street Address
						"<p class='summaryList'> Street Address: <summaryBold> {providePreviousOutsideUSStreetAddress} </summaryBold></p>",
						// Apartment
						"<p class='summaryList'> Apt/Unit/Suite: <summaryBold> none </summaryBold></p>",
						// City
						"<p class='summaryList'> City: <summaryBold> {providePreviousCity} </summaryBold></p>",
						// State
						"<p class='summaryList'> State/Province/Region: <summaryBold> {providePreviousOutsideUSState} </summaryBold></p>",
						// Zip Code
						"<p class='summaryList'> Zip Code: <summaryBold> {providePreviousZipCode} </summaryBold></p>",
						// Country
						"<p class='summaryList'> Country: <summaryBold> {providePreviousOutsideUSCountry} </summaryBold></p>",
					].join(''),
					Spanish: [
						// Street Address
						"<p class='summaryList'> Dirección: <summaryBold> {providePreviousOutsideUSStreetAddress} </summaryBold></p>",
						// Apartment
						"<p class='summaryList'> Apto/Unidad/Suite: <summaryBold> ninguno </summaryBold></p>",
						// City
						"<p class='summaryList'> Ciudad: <summaryBold> {providePreviousCity} </summaryBold></p>",
						// State
						"<p class='summaryList'> Estado/Provincia/Región: <summaryBold> {providePreviousOutsideUSState} </summaryBold></p>",
						// Zip Code
						"<p class='summaryList'> Código Postal: <summaryBold> {providePreviousZipCode} </summaryBold></p>",
						// Country
						"<p class='summaryList'> País: <summaryBold> {providePreviousOutsideUSCountry} </summaryBold></p>",
					].join(''),
				},
				//NOTE: If the previous Outside US address has an apartment, then the apartment will be the previous apartment #
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.addressLine2',
							comparisonType: 'different',
							value: null,
						},
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'providePreviousOutsideUSCountry',
							dataPathType: 'array',
						},
					],
					English: [
						// Street Address
						"<p class='summaryList'> Street Address: <summaryBold> {providePreviousOutsideUSStreetAddress} </summaryBold></p>",
						// Apartment
						"<p class='summaryList'> Apt/Unit/Suite: <summaryBold> {providePreviousApartment} </summaryBold></p>",
						// City
						"<p class='summaryList'> City: <summaryBold> {providePreviousCity} </summaryBold></p>",
						// State
						"<p class='summaryList'> State/Province/Region: <summaryBold> {providePreviousOutsideUSState} </summaryBold></p>",
						// Zip Code
						"<p class='summaryList'> Zip Code: <summaryBold> {providePreviousZipCode} </summaryBold></p>",
						// Country
						"<p class='summaryList'> Country: <summaryBold> {providePreviousOutsideUSCountry} </summaryBold></p>",
					].join(''),
					Spanish: [
						// Street Address
						"<p class='summaryList'> Dirección: <summaryBold> {providePreviousOutsideUSStreetAddress} </summaryBold></p>",
						// Apartment
						"<p class='summaryList'> Apto/Unidad/Suite: <summaryBold> {providePreviousApartment} </summaryBold></p>",
						// City
						"<p class='summaryList'> Ciudad: <summaryBold> {providePreviousCity} </summaryBold></p>",
						// State
						"<p class='summaryList'> Estado/Provincia/Región: <summaryBold> {providePreviousOutsideUSState} </summaryBold></p>",
						// Zip Code
						"<p class='summaryList'> Código Postal: <summaryBold> {providePreviousZipCode} </summaryBold></p>",
						// Country
						"<p class='summaryList'> País: <summaryBold> {providePreviousOutsideUSCountry} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Moved In Date
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate',
							comparisonType: 'less',
							value: '24',
							dataPathType: 'date',
						},
					],
					English: ["<p class='summaryList'> Moved In Date: <summaryBold> {providePreviousMovedInDate} </summaryBold>.</p>"].join(''),
					Spanish: ["<p class='summaryList'> Fecha de Mudanza: <summaryBold> {providePreviousMovedInDate} </summaryBold>.</p>"].join(''),
				},
			],
			answerButtons: [
				{
					label: 'yesSummary',
					actions: [
						{
							action: 2,
							nextQuestion: 'currentlyEmployed',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'dateCompleted',
											comparisonType: 'different',
											value: null,
										},
									],
									goTo: 'applicationUpdatedCreditAppSummary1',
								},
							],
						},
						{
							action: 5,
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'noSummary',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideMovedInDate',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},

		// **** Income Related ****
		{
			key: 'currentlyEmployed',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Are you currently employed?',
					Spanish: '¿Tiene un empleo actualmente?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 4,
							apiMethod: 'resetDateCompleted',
						},
						{
							action: 1,
							overrides: [
								{
									value: 'employed',
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'employedWithMilitary',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 4,
							apiMethod: 'resetDateCompleted',
						},
						{
							action: 2,
							nextQuestion: 'noEmployedStatus',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.employmentStatus',
			prevQuestion: true,
			isFirstInGroup: true,
		},
		{
			key: 'employedWithMilitary',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Are you employed by the Military?',
					Spanish: '¿Trabaja para las Fuerzas Armadas?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 1,
							overrides: [
								{
									value: ENUMS.CREDIT_APP_TYPE_EMPLOYEE.MILITARY,
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'provideMilitaryCurrentEmployerName',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'employmentType',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.employeeType',
			prevQuestion: true,
		},
		{
			key: 'provideMilitaryCurrentEmployerName',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is your current military branch?',
					Spanish: '¿En que rama de las fuerzas armadas trabaja actualmente?',
				},
			],
			dropdown: {
				listMethod: 'militaryBranch',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideMilitaryCurrentEmployerPhoneNumber',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.employerName',
			prevQuestion: true,
		},
		{
			key: 'provideMilitaryCurrentEmployerPhoneNumber',
			category: 'creditApp',
			type: 'QuestionInputPhone',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'maxLength',
							params: [10],
						},
						{
							type: 'minLength',
							params: [10],
						},
						{
							type: 'numeric',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is the main phone number for {provideMilitaryCurrentEmployerName}?',
					Spanish: '¿Cual es el número de teléfono principal de {provideMilitaryCurrentEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideMilitaryCurrentEmployerPosition',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.phone',
			prevQuestion: true,
		},
		{
			key: 'provideMilitaryCurrentEmployerPosition',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is your position in the {provideMilitaryCurrentEmployerName}?',
					Spanish: '¿Cuál es su posición en el/la {provideMilitaryCurrentEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideMilitaryCurrentEmployerStartedDate',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.position',
			prevQuestion: true,
		},
		// {
		//     key: 'provideMilitaryCurrentEmployerSupervisorFirstName',
		//     category: 'creditApp',
		//     type: 'QuestionInputText',
		//     validation: [
		//         {
		//             propertyName: 'textValue',
		//             validators: [
		//                 {
		//                     type: 'required'
		//                 },
		//             ]
		//         }
		//     ],
		//     summaryDisplay: true,
		//     textsToShow: [
		//         {
		//             conditionToShow: null,
		//             English: 'What is the first of your immediate supervisor?',
		//             Spanish: '¿Cuál es el nombre de su supervisor inmediato?'
		//         },
		//     ],
		//     answerButtons: [
		//         {
		//             label: 'continue',
		//             isValidationRequired: true,
		//             actions: [
		//                 {
		//                     action: 1,
		//                 },
		//                 {
		//                     action: 2,
		//                     nextQuestion: 'provideMilitaryCurrentEmployerSupervisorLastName'
		//                 }
		//             ],
		//             style: {
		//                 background: 'successButtonColor',
		//                 text: 'successButtonTextColor'
		//             }
		//         }
		//     ],
		//     savedAnswer: null,
		//     dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.supervisorFirstName',
		//     prevQuestion: true,
		// },
		// {
		//     key: 'provideMilitaryCurrentEmployerSupervisorLastName',
		//     category: 'creditApp',
		//     type: 'QuestionInputText',
		//     validation: [
		//         {
		//             propertyName: 'textValue',
		//             validators: [
		//                 {
		//                     type: 'required'
		//                 },
		//             ]
		//         }
		//     ],
		//     summaryDisplay: true,
		//     textsToShow: [
		//         {
		//             conditionToShow: null,
		//             English: 'What is the last name of your immediate supervisor?',
		//             Spanish: '¿Cuál es el(los) apellido(s) de su supervisor inmediato?'
		//         },
		//     ],
		//     answerButtons: [
		//         {
		//             label: 'continue',
		//             isValidationRequired: true,
		//             actions: [
		//                 {
		//                     action: 1,
		//                 },
		//                 {
		//                     action: 2,
		//                     nextQuestion: 'provideMilitaryCurrentEmployerSupervisorPhoneNumber'
		//                 }
		//             ],
		//             style: {
		//                 background: 'successButtonColor',
		//                 text: 'successButtonTextColor'
		//             }
		//         }
		//     ],
		//     savedAnswer: null,
		//     dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.supervisorLastName',
		//     prevQuestion: true,
		// },
		// {
		//     key: 'provideMilitaryCurrentEmployerSupervisorPhoneNumber',
		//     category: 'creditApp',
		//     type: 'QuestionInputPhone',
		//     validation: [
		//         {
		//             propertyName: 'textValue',
		//             validators: [
		//                 {
		//                     type: 'required'
		//                 },
		//                 {
		//                     type: 'maxLength',
		//                     params: [10]
		//                 },
		//                 {
		//                     type: 'minLength',
		//                     params: [10]
		//                 },
		//                 {
		//                     type: 'numeric',
		//                 },
		//             ]
		//         }
		//     ],
		//     summaryDisplay: true,
		//     textsToShow: [
		//         {
		//             conditionToShow: null,
		//             English: "What is {provideMilitaryCurrentEmployerSupervisorFirstName} {provideMilitaryCurrentEmployerSupervisorLastName}'s phone number?",
		//             Spanish: '¿Cuál es el número de teléfono de {provideMilitaryCurrentEmployerSupervisorFirstName[ {provideMilitaryCurrentEmployerSupervisorLastName}?'
		//         },
		//     ],
		//     answerButtons: [
		//         {
		//             label: 'continue',
		//             isValidationRequired: true,
		//             actions: [
		//                 {
		//                     action: 1,
		//                 },
		//                 {
		//                     action: 2,
		//                     nextQuestion: 'provideMilitaryCurrentEmployerStartedDate'
		//                 }
		//             ],
		//             style: {
		//                 background: 'successButtonColor',
		//                 text: 'successButtonTextColor'
		//             }
		//         }
		//     ],
		//     savedAnswer: null,
		//     dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.supervisorPhone',
		//     prevQuestion: true,
		// },
		{
			key: 'provideMilitaryCurrentEmployerStartedDate',
			category: 'creditApp',
			type: 'QuestionDate',
			dateType: 'month',
			validation: [
				{
					propertyName: 'year',
					validators: [
						{
							type: 'required',
						},
					],
				},
				{
					propertyName: 'month',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'When did you start working at {provideMilitaryCurrentEmployerName}?',
					Spanish: '¿Cuándo empezó a trabajar en {provideMilitaryCurrentEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'howGetPay',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.startDate',
			prevQuestion: true,
		},
		{
			key: 'employmentType',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Are you a employed under W2 or 1099?',
					Spanish: '¿Estás empleado bajo un W2 o un 1099?',
				},
			],
			notesToShow: [
				{
					conditionToShow: null,
					English: 'W2: My employer takes out taxes and social security before paying me.',
					Spanish: 'W2: My empleador retira mis impuestos y seguridad social antes de pagarme.',
				},
				{
					conditionToShow: null,
					English: "1099: My employer pays me and it's my responsibility to file and pay my taxes and social security",
					Spanish: '1099: My empleador me paga y es mi responsabilidad declarar y pagar mis impuestos y seguridad social',
				},
			],
			dropdown: {
				listMethod: 'employmentFormType',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideCurrentEmployerName',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.employeeType',
			prevQuestion: true,
		},
		{
			key: 'provideCurrentEmployerName',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: "What is your employer's business name?",
					Spanish: '¿Cuál es el nombre de la compañía en que trabaja?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideCurrentEmployerPhoneNumber',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.employerName',
			prevQuestion: true,
		},
		{
			key: 'provideCurrentEmployerPhoneNumber',
			category: 'creditApp',
			type: 'QuestionInputPhone',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'maxLength',
							params: [10],
						},
						{
							type: 'minLength',
							params: [10],
						},
						{
							type: 'numeric',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is the main phone number for {provideCurrentEmployerName}?',
					Spanish: '¿Cuál es el número de teléfono principal de {provideCurrentEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideCurrentEmployerPosition',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.phone',
			prevQuestion: true,
		},
		{
			key: 'provideCurrentEmployerPosition',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is your position at {provideCurrentEmployerName}?',
					Spanish: '¿Cuál es su posición en {provideCurrentEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideCurrentEmployerStartedDate',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.position',
			prevQuestion: true,
		},
		// {
		//     key: 'provideCurrentEmployerSupervisorFirstName',
		//     category: 'creditApp',
		//     type: 'QuestionInputText',
		//     validation: [
		//         {
		//             propertyName: 'textValue',
		//             validators: [
		//                 {
		//                     type: 'required'
		//                 },
		//             ]
		//         }
		//     ],
		//     summaryDisplay: true,
		//     textsToShow: [
		//         {
		//             conditionToShow: null,
		//             English: 'What is the first name of your immediate supervisor?',
		//             Spanish: '¿Cuál es el nombre de su supervisor inmediato?'
		//         },
		//     ],
		//     answerButtons: [
		//         {
		//             label: 'continue',
		//             isValidationRequired: true,
		//             actions: [
		//                 {
		//                     action: 1,
		//                 },
		//                 {
		//                     action: 2,
		//                     nextQuestion: 'provideCurrentEmployerSupervisorLastName'
		//                 }
		//             ],
		//             style: {
		//                 background: 'successButtonColor',
		//                 text: 'successButtonTextColor'
		//             }
		//         }
		//     ],
		//     savedAnswer: null,
		//     dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.supervisorFirstName',
		//     prevQuestion: true,
		// },
		// {
		//     key: 'provideCurrentEmployerSupervisorLastName',
		//     category: 'creditApp',
		//     type: 'QuestionInputText',
		//     validation: [
		//         {
		//             propertyName: 'textValue',
		//             validators: [
		//                 {
		//                     type: 'required'
		//                 },
		//             ]
		//         }
		//     ],
		//     summaryDisplay: true,
		//     textsToShow: [
		//         {
		//             conditionToShow: null,
		//             English: 'What is the last name of your immediate supervisor?',
		//             Spanish: '¿Cuál es el(los) apellido(s) de su supervisor inmediato?'
		//         },
		//     ],
		//     answerButtons: [
		//         {
		//             label: 'continue',
		//             isValidationRequired: true,
		//             actions: [
		//                 {
		//                     action: 1,
		//                 },
		//                 {
		//                     action: 2,
		//                     nextQuestion: 'provideCurrentEmployerSupervisorPhoneNumber'
		//                 }
		//             ],
		//             style: {
		//                 background: 'successButtonColor',
		//                 text: 'successButtonTextColor'
		//             }
		//         }
		//     ],
		//     savedAnswer: null,
		//     dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.supervisorLastName',
		//     prevQuestion: true,
		// },
		// {
		//     key: 'provideCurrentEmployerSupervisorPhoneNumber',
		//     category: 'creditApp',
		//     type: 'QuestionInputPhone',
		//     validation: [
		//         {
		//             propertyName: 'textValue',
		//             validators: [
		//                 {
		//                     type: 'required'
		//                 },
		//                 {
		//                     type: 'maxLength',
		//                     params: [10]
		//                 },
		//                 {
		//                     type: 'minLength',
		//                     params: [10]
		//                 },
		//                 {
		//                     type: 'numeric',
		//                 },
		//             ]
		//         }
		//     ],
		//     summaryDisplay: true,
		//     textsToShow: [
		//         {
		//             conditionToShow: null,
		//             English: "What is {provideMilitaryCurrentEmployerSupervisorFirstName} {provideMilitaryCurrentEmployerSupervisorLastName}'s phone number?",
		//             Spanish: '¿Cuál es el número de teléfono de {provideMilitaryCurrentEmployerSupervisorFirstName} {provideMilitaryCurrentEmployerSupervisorLastName}?'
		//         },
		//     ],
		//     answerButtons: [
		//         {
		//             label: 'continue',
		//             isValidationRequired: true,
		//             actions: [
		//                 {
		//                     action: 1,
		//                 },
		//                 {
		//                     action: 2,
		//                     nextQuestion: 'provideCurrentEmployerStartedDate'
		//                 }
		//             ],
		//             style: {
		//                 background: 'successButtonColor',
		//                 text: 'successButtonTextColor'
		//             }
		//         }
		//     ],
		//     savedAnswer: null,
		//     dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.supervisorPhone',
		//     prevQuestion: true,
		// },
		{
			key: 'provideCurrentEmployerStartedDate',
			category: 'creditApp',
			type: 'QuestionDate',
			dateType: 'month',
			validation: [
				{
					propertyName: 'year',
					validators: [
						{
							type: 'required',
						},
					],
				},
				{
					propertyName: 'month',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'When did you start working at {provideCurrentEmployerName}?',
					Spanish: '¿Cuándo empezó a trabajar en {provideCurrentEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'howGetPay',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.startDate',
			prevQuestion: true,
		},
		{
			key: 'howGetPay',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How do you get paid?',
					Spanish: '¿Cómo recibe su pago?',
				},
			],
			dropdown: {
				listMethod: 'paymentType',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'annualSalary',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.payType',
											comparisonType: 'equal',
											value: 'hourly',
										},
									],
									goTo: 'getPaidOvertime',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.payType',
			prevQuestion: true,
		},
		{
			key: 'getPaidOvertime',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Do you get paid overtime when working more that 40 hours a week?',
					Spanish: '¿Le pagan horas extras cuando trabaja mas de 40 horas a la semana?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'hourlyRate',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'hourlyRate',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.getPaidOvertime',
			prevQuestion: true,
		},
		{
			key: 'hourlyRate',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How much do you get paid an hour?',
					Spanish: '¿Cuánto le pagan por hora?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'hoursWorkedPerWeek',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.payAmount',
			prevQuestion: true,
		},
		{
			key: 'hoursWorkedPerWeek',
			category: 'creditApp',
			type: 'QuestionInputNumber',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How many hours per week you work on average?',
					Spanish: '¿Cuántas horas promedio trabaja en la semana?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'getCommissionsOrBonuses',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.weeklyHours',
			prevQuestion: true,
		},
		{
			key: 'annualSalary',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.employeeType',
							comparisonType: 'equal',
							value: ENUMS.CREDIT_APP_TYPE_EMPLOYEE.MILITARY,
						},
					],
					English: 'What is your annual salary without any deductions?',
					Spanish: '¿Cuál es su salario anual sin deducciones?',
				},
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.employeeType',
							comparisonType: 'equal',
							value: ENUMS.CREDIT_APP_TYPE_EMPLOYEE.W2,
						},
					],
					English: 'What is your annual salary without any deductions?',
					Spanish: '¿Cuál es su salario anual sin deducciones?',
				},
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.employeeType',
							comparisonType: 'equal',
							value: ENUMS.CREDIT_APP_TYPE_EMPLOYEE.SE1099,
						},
					],
					English: 'What is your annual salary?',
					Spanish: '¿Cuál es su salario anual?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'getCommissionsOrBonuses',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.payAmount',
			prevQuestion: true,
		},
		{
			key: 'getCommissionsOrBonuses',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Do you get paid any commissions and/or bonuses above your regular pay?',
					Spanish: '¿Le pagan comisiones y/o bonos ademas de su salario regular?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'commissionsOrBonusesFrequency',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'previouslyEmployed',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.startDate', // provideCurrentEmployerStartedDate
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],
									goTo: 'receivePension',
								},
							],
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'commissionsOrBonusesFrequency',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How often do you get commissions and/or bonuses?',
					Spanish: '¿Con qué frecuencia recibe comisiones y/o bonos ?',
				},
			],
			dropdown: {
				listMethod: 'frequenciesWithoutQuarterlyAndSemiAnnual',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'commissionsOrBonusesAmount',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.commissionsAndBonusesFrequency',
			prevQuestion: true,
		},
		{
			key: 'commissionsOrBonusesAmount',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter amount of commissions and/or bonuses',
					Spanish: 'Por favor ingrese la cantidad de comisiones y/o bonos',
				},
			],
			answerButtons: [
				{
					label: 'continue',

					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'commissionsOrBonusesDescription',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.commissionsAndBonusesAmount',
			prevQuestion: true,
		},
		{
			key: 'commissionsOrBonusesDescription',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter a brief description of your commissions and/or bonuses.',
					Spanish: 'Por favor describa brevemente sus comisiones y/o bonos.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'previouslyEmployed',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.startDate', // provideCurrentEmployerStartedDate
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],

									goTo: 'receivePension',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.commissionsAndBonusesDescription',
			prevQuestion: true,
		},
		{
			key: 'previouslyEmployed',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Were you previously employed?',
					Spanish: '¿Estuvo empleado anteriormente?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'previouslyEmployedWithMilitary',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'receivePension',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'previouslyEmployedWithMilitary',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Were you previously employed by the Military?',
					Spanish: '¿Trabajó anteriormente para las Fuerzas Armadas?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'provideMilitaryPreviousEmployerName',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 2,
							nextQuestion: 'providePreviousEmployerName',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'provideMilitaryPreviousEmployerName',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is your previous military branch?',
					Spanish: '¿En qué rama de las fuerzas armadas trabajó anteriormente?',
				},
			],
			dropdown: {
				listMethod: 'militaryBranch',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideMilitaryPreviousEmployerPhoneNumber',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousEmployment.employerName',
			prevQuestion: true,
		},
		{
			key: 'provideMilitaryPreviousEmployerPhoneNumber',
			category: 'creditApp',
			type: 'QuestionInputPhone',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'maxLength',
							params: [10],
						},
						{
							type: 'minLength',
							params: [10],
						},
						{
							type: 'numeric',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is the main phone number for {provideMilitaryPreviousEmployerName}?',
					Spanish: '¿Cuál es el número de teléfono principal de {provideMilitaryPreviousEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideMilitaryPreviousEmployerPosition',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousEmployment.phone',
			prevQuestion: true,
		},
		{
			key: 'provideMilitaryPreviousEmployerPosition',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What was your position at {provideMilitaryPreviousEmployerName}?',
					Spanish: '¿Cuál fue su posición en {provideMilitaryPreviousEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideMilitaryPreviousEmployerStartedDate',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousEmployment.position',
			prevQuestion: true,
		},
		{
			key: 'provideMilitaryPreviousEmployerStartedDate',
			category: 'creditApp',
			type: 'QuestionDate',
			dateType: 'month',
			validation: [
				{
					propertyName: 'year',
					validators: [
						{
							type: 'required',
						},
					],
				},
				{
					propertyName: 'month',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'When did you start working at {provideMilitaryPreviousEmployerName}?',
					Spanish: '¿Cuándo empezó a trabajar en {provideMilitaryPreviousEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'receivePension',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousEmployment.startDate',
			prevQuestion: true,
		},
		{
			key: 'providePreviousEmployerName',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is your previous employer name?',
					Spanish: '¿Cuál es el nombre de su centro de trabajo anterior?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousEmployerPhoneNumber',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousEmployment.employerName',
			prevQuestion: true,
		},
		{
			key: 'providePreviousEmployerPhoneNumber',
			category: 'creditApp',
			type: 'QuestionInputPhone',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'maxLength',
							params: [10],
						},
						{
							type: 'minLength',
							params: [10],
						},
						{
							type: 'numeric',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is the main phone number for {providePreviousEmployerName}?',
					Spanish: '¿Cuál es el número de teléfono principal de {providePreviousEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousEmployerPosition',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousEmployment.phone',
			prevQuestion: true,
		},
		{
			key: 'providePreviousEmployerPosition',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is your position at {providePreviousEmployerName}?',
					Spanish: '¿Cuál es su posición en {providePreviousEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'providePreviousEmployerStartedDate',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousEmployment.position',
			prevQuestion: true,
		},
		{
			key: 'providePreviousEmployerStartedDate',
			category: 'creditApp',
			type: 'QuestionDate',
			dateType: 'month',
			validation: [
				{
					propertyName: 'year',
					validators: [
						{
							type: 'required',
						},
					],
				},
				{
					propertyName: 'month',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'When did you start working at {providePreviousEmployerName}?',
					Spanish: '¿Cuándo empezó a trabajar en {providePreviousEmployerName}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'receivePension',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.previousEmployment.startDate',
			prevQuestion: true,
		},
		{
			key: 'noEmployedStatus',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please select one of the following statuses.',
					Spanish: 'Por favor seleccione uno de los siguentes estados.',
				},
			],
			dropdown: {
				listMethod: 'noEmployedStatus',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'provideNonEmployedStatusStartDate',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.employmentStatus',
											comparisonType: 'equal',
											value: 'other',
										},
									],
									goTo: 'incomeSituationDescription',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.employmentStatus',
			prevQuestion: true,
		},
		{
			key: 'provideNonEmployedStatusStartDate',
			category: 'creditApp',
			type: 'QuestionDate',
			dateType: 'month',
			validation: [
				{
					propertyName: 'year',
					validators: [
						{
							type: 'required',
						},
					],
				},
				{
					propertyName: 'month',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.employmentStatus',
							comparisonType: 'different',
							value: 'other',
						},
					],
					English: 'When did your status become {noEmployedStatus}?',
					Spanish: '¿Cuándo empezó su estado de {noEmployedStatus}?',
				},
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.employmentStatus',
							comparisonType: 'equal',
							value: 'other',
						},
					],
					English: 'When did your status become {incomeSituationDescription}?',
					Spanish: '¿Cuándo empezó su estado de {incomeSituationDescription}?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'receivePension',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.employmentStatus',
											comparisonType: 'equal',
											value: 'retired',
										},
									],
									goTo: 'receiveSocialSecurity',
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.employmentStatus',
											comparisonType: 'equal',
											value: 'disabled',
										},
									],
									goTo: 'receiveSupplementalSecurity',
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.employmentStatus',
											comparisonType: 'equal',
											value: 'student',
										},
									],
									goTo: 'studentSchoolName',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.nonEmployedStatusStartDate',
			prevQuestion: true,
		},
		{
			key: 'receiveSocialSecurity',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Do you receive Social Security payments?',
					Spanish: '¿Recibe pagos de la Seguridad Social?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'socialSecurityFrequency',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.socialSecurity.frequency',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.socialSecurity.amount',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.socialSecurity.description',
									override: {
										value: null,
										type: 'value',
									},
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'previouslyEmployed',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.nonEmployedStatusStartDate',
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],

									goTo: 'receivePension',
								},
							],
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'socialSecurityFrequency',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How often do you receive your Social Security payment?',
					Spanish: '¿Con qué frecuencia recibe su pago de la Seguridad Social?',
				},
			],
			dropdown: {
				listMethod: 'frequenciesWithoutQuarterlyAndSemiAnnual',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'socialSecurityAmount',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.socialSecurity.frequency',
			prevQuestion: true,
		},
		{
			key: 'socialSecurityAmount',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the amount you receive from Social Security.',
					Spanish: 'Por favor ingrese la cantidad que recibe de la Seguridad Social.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'previouslyEmployed',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.nonEmployedStatusStartDate',
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],

									goTo: 'receivePension',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.socialSecurity.amount',
			prevQuestion: true,
		},
		{
			key: 'receiveSupplementalSecurity',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Do you receive Supplemental Security (disability) payments?',
					Spanish: '¿Recibe pagos de Segurida Suplementaria (discapacitado)?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'supplementalSecurityFrequency',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.supplementalSecurity.frequency',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.supplementalSecurity.amount',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.supplementalSecurity.description',
									override: {
										value: null,
										type: 'value',
									},
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'previouslyEmployed',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.nonEmployedStatusStartDate',
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],

									goTo: 'receivePension',
								},
							],
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'supplementalSecurityFrequency',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How often do you receive Supplemental Security?',
					Spanish: '¿Con qué frecuencia recibe Seguridad Suplementaria?',
				},
			],
			dropdown: {
				listMethod: 'frequenciesWithoutQuarterlyAndSemiAnnual',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'supplementalSecurityAmount',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.supplementalSecurity.frequency',
			prevQuestion: true,
		},
		{
			key: 'supplementalSecurityAmount',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the amount you receive from Supplemental Security.',
					Spanish: 'Por favor ingrese la cantidad que recibe en Seguridad Suplementaria.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'previouslyEmployed',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.nonEmployedStatusStartDate',
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],

									goTo: 'receivePension',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.supplementalSecurity.amount',
			prevQuestion: true,
		},
		{
			key: 'studentSchoolName',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'What is the name of the school you attend?',
					Spanish: '¿Cuál es el nombre de la escuela a la que asite?',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'receivePension',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.studentSchoolName',
			prevQuestion: true,
		},
		{
			key: 'incomeSituationDescription',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please briefly describe your income situation.',
					Spanish: 'Por favor describa brevemente su situacion financiera.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'previouslyEmployed',
							conditions: [
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.employmentStatus',
											comparisonType: 'equal',
											value: 'other',
										},
									],
									goTo: 'provideNonEmployedStatusStartDate',
								},
								{
									conditionList: [
										{
											dataPath: 'quoteAppData.applicationsDataAnswered.personalInfo.nonEmployedStatusStartDate',
											comparisonType: 'greaterOrEqual',
											value: '24',
											dataPathType: 'date',
										},
									],
									goTo: 'receivePension',
								},
							],
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.incomeSituationDescription',
			prevQuestion: true,
		},
		{
			key: 'receivePension',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Do you receive any pension payments?',
					Spanish: '¿Recibe pagos de pensión(es)?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'pensionFrequency',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.pension.frequency',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.pension.amount',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.pension.description',
									override: {
										value: null,
										type: 'value',
									},
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'haveInvestment',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'pensionFrequency',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How often do you receive pension(s)?',
					Spanish: '¿Con qué frecuencia recibe pensión(es)?',
				},
			],
			dropdown: {
				listMethod: 'frequenciesWithoutQuarterlyAndSemiAnnual',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'pensionAmount',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.pension.frequency',
			prevQuestion: true,
		},
		{
			key: 'pensionAmount',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the amount you receive from your pension(s).',
					Spanish: 'Por favor ingrese la cantidad que recibe se su(s) pensión(es).',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'haveInvestment',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.pension.amount',
			prevQuestion: true,
		},
		{
			key: 'haveInvestment',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Do you have any income from investments?',
					Spanish: '¿Tiene algún ingreso por inversiones?',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'investmentFrequency',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.investment.frequency',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.investment.amount',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.investment.description',
									override: {
										value: null,
										type: 'value',
									},
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'haveOtherIncome',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'investmentFrequency',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How often do you receive income from your investment(s)?',
					Spanish: '¿Con qué frecuencia recibe ingresos de su(s) inversión(es)?',
				},
			],
			dropdown: {
				listMethod: 'allFrequencies',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'investmentAmount',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.investment.frequency',
			prevQuestion: true,
		},
		{
			key: 'investmentAmount',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter the income you receive from your investment(s).',
					Spanish: 'Por favor ingrese la cantidad que recibe por su(s) inversión(es).',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'investmentDescription',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.investment.amount',
			prevQuestion: true,
		},
		{
			key: 'investmentDescription',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please briefly describe the investment(s).',
					Spanish: 'Por favor describa brevemente su(s) inversion(es).',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'haveOtherIncome',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.investment.description',
			prevQuestion: true,
		},
		{
			key: 'haveOtherIncome',
			category: 'creditApp',
			type: 'QuestionYesNo',
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Do you have another source of income?',
					Spanish: '¿Tiene alguna otra fuente de ingresos?',
				},
			],
			notesToShow: [
				{
					conditionToShow: null,
					English:
						'Alimony, child support, or separate maintenance income need not be revealed if the applicant does not want the creditor to consider it in determining the applicant’s creditworthiness.',
					Spanish:
						'Los ingresos de alquiler, apoyo de los hijos, o mantenimiento separado no necesitan ser revelados si el solicitante no desea que el acreedor considere estos ingresos en la determinación de laworthiness crediticia del solicitante.',
				},
			],
			answerButtons: [
				{
					label: 'yes',
					actions: [
						{
							action: 2,
							nextQuestion: 'otherIncomeFrequency',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'no',
					actions: [
						{
							action: 3,
							extraValuesToSave: [
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.otherIncome.frequency',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.otherIncome.amount',
									override: {
										value: null,
										type: 'value',
									},
								},
								{
									type: 'value',
									savePath: 'quoteAppData.applicationsDataAnswered.personalInfo.otherIncome.description',
									override: {
										value: null,
										type: 'value',
									},
								},
							],
						},
						{
							action: 2,
							nextQuestion: 'creditAppSummary2',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},
		{
			key: 'otherIncomeFrequency',
			category: 'creditApp',
			type: 'QuestionInputDropdown',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'How often do you receive additional income?',
					Spanish: '¿Con qué frecuencia recibe ingresos adicionales?',
				},
			],
			dropdown: {
				listMethod: 'allFrequencies',
				keys: {
					text: 'text',
					value: 'value',
				},
			},
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'otherIncomeAmount',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.otherIncome.frequency',
			prevQuestion: true,
		},
		{
			key: 'otherIncomeAmount',
			category: 'creditApp',
			type: 'QuestionInputCurrency',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
						{
							type: 'minValue',
							params: [1],
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter amount of additional income.',
					Spanish: 'Por favor ingrese la cantidad de ingresos adicionales.',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'otherIncomeDescription',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.otherIncome.amount',
			prevQuestion: true,
		},
		{
			key: 'otherIncomeDescription',
			category: 'creditApp',
			type: 'QuestionInputText',
			validation: [
				{
					propertyName: 'textValue',
					validators: [
						{
							type: 'required',
						},
					],
				},
			],
			summaryDisplay: true,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please enter a brief description of your additional income',
					Spanish: 'Por favor describa brevemente sus incresos adicionales',
				},
			],
			answerButtons: [
				{
					label: 'continue',
					isValidationRequired: true,
					actions: [
						{
							action: 1,
						},
						{
							action: 2,
							nextQuestion: 'creditAppSummary2',
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: 'quoteAppData.applicationsDataAnswered.personalInfo.otherIncome.description',
			prevQuestion: true,
		},
		{
			key: 'creditAppSummary2',
			category: 'creditApp',
			type: 'QuestionSummary',
			triggerSave: true,
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Please review all the information below and confirm if it is correct.',
					Spanish: 'Por favor, revise toda la siguiente información y confirme si esta correcta.',
				},
				// *** Income Related ***
				//NOTE: Employment Status and Start Date for Non-Employed
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'noEmployedStatus',
							dataPathType: 'array',
						},
					],
					English: [
						"<p class='summaryList'> Employment Information: </p>",
						"<p class='summaryList'> Status: <summaryBold> {noEmployedStatus} </summaryBold></p>",
						"<p class='summaryList'> Since: <summaryBold> {provideNonEmployedStatusStartDate} </summaryBold></p>",
					].join(''),
					Spanish: [
						"<p class='summaryList'> Información Laboral: </p>",
						"<p class='summaryList'> Estado: <summaryBold> {noEmployedStatus} </summaryBold></p>",
						"<p class='summaryList'> Desde: <summaryBold> {provideNonEmployedStatusStartDate} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Social Security
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'socialSecurityFrequency',
							dataPathType: 'array',
						},
					],
					English: ["<p class='summaryList'> Social Security Payment: <summaryBold> {socialSecurityAmount} {socialSecurityFrequency} </summaryBold></p>"].join(
						'',
					),
					Spanish: ["<p class='summaryList'> Pago de Seguro Social: <summaryBold> {socialSecurityAmount} {socialSecurityFrequency} </summaryBold></p>"].join(
						'',
					),
				},
				//NOTE: Supplemental Security
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'supplementalSecurityFrequency',
							dataPathType: 'array',
						},
					],
					English: [
						"<p class='summaryList'> Supplemental Security Payment: <summaryBold> {supplementalSecurityAmount} {supplementalSecurityFrequency} </summaryBold></p>",
					].join(''),
					Spanish: [
						"<p class='summaryList'> Pago de Seguro Suplementario: <summaryBold> {supplementalSecurityAmount} {supplementalSecurityFrequency} </summaryBold></p>",
					].join(''),
				},
				//NOTE: School Name
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'studentSchoolName',
							dataPathType: 'array',
						},
					],
					English: ["<p class='summaryList'> School Name: <summaryBold> {studentSchoolName} </summaryBold></p>"].join(''),
					Spanish: ["<p class='summaryList'> Nombre de la Escuela: <summaryBold> {studentSchoolName} </summaryBold></p>"].join(''),
				},
				//NOTE: Other Status
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'incomeSituationDescription',
							dataPathType: 'array',
						},
					],
					English: ["<p class='summaryList'> Description: <summaryBold> {incomeSituationDescription} </summaryBold></p>"].join(''),
					Spanish: ["<p class='summaryList'> Descripción: <summaryBold> {incomeSituationDescription} </summaryBold></p>"].join(''),
				},
				//NOTE: Current Employment (Military)
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideMilitaryCurrentEmployerName',
							dataPathType: 'array',
						},
					],
					English: [
						"<p class='summaryList'> Current Employment Information:</p>",
						"<p class='summaryList'> Position: <summaryBold> {provideMilitaryCurrentEmployerPosition} </summaryBold></p>",
						"<p class='summaryList'> Employer Name: <summaryBold> {provideMilitaryCurrentEmployerName} </summaryBold></p>",
						"<p class='summaryList'> Start Date: <summaryBold> {provideMilitaryCurrentEmployerStartedDate} </summaryBold></p>",
						"<p class='summaryList'> Employer Phone: <summaryBold> {provideMilitaryCurrentEmployerPhoneNumber} </summaryBold></p>",
					].join(''),
					Spanish: [
						"<p class='summaryList'> Información del Empleo Actual:</p>",
						"<p class='summaryList'> Posición: <summaryBold> {provideMilitaryCurrentEmployerPosition} </summaryBold></p>",
						"<p class='summaryList'> Nombre del Empleador: <summaryBold> {provideMilitaryCurrentEmployerName} </summaryBold></p>",
						"<p class='summaryList'> Fecha de inicio: <summaryBold> {provideMilitaryCurrentEmployerStartedDate} </summaryBold></p>",
						"<p class='summaryList'> Teléfono del Empleador: <summaryBold> {provideMilitaryCurrentEmployerPhoneNumber} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Current Employment (Non-Military)
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideCurrentEmployerName',
							dataPathType: 'array',
						},
					],
					English: [
						"<p class='summaryList'> Current Employment Information:</p>",
						"<p class='summaryList'> Position: <summaryBold> {provideCurrentEmployerPosition} </summaryBold></p>",
						"<p class='summaryList'> Employer Name: <summaryBold> {provideCurrentEmployerName} </summaryBold></p>",
						"<p class='summaryList'> Start Date: <summaryBold> {provideCurrentEmployerStartedDate} </summaryBold></p>",
						"<p class='summaryList'> Employer Phone: <summaryBold> {provideCurrentEmployerPhoneNumber} </summaryBold></p>",
					].join(''),
					Spanish: [
						"<p class='summaryList'> Información del Empleo Actual:</p>",
						"<p class='summaryList'> Posición: <summaryBold> {provideCurrentEmployerPosition} </summaryBold></p>",
						"<p class='summaryList'> Nombre del Empleador: <summaryBold> {provideCurrentEmployerName} </summaryBold></p>",
						"<p class='summaryList'> Fecha de inicio: <summaryBold> {provideCurrentEmployerStartedDate} </summaryBold></p>",
						"<p class='summaryList'> Teléfono del Empleador: <summaryBold> {provideCurrentEmployerPhoneNumber} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Hourly Rate
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'hourlyRate',
							dataPathType: 'array',
						},
					],
					English: [
						"<p class='summaryList'> Hourly Wage: <summaryBold> {hourlyRate} </summaryBold></p>",
						"<p class='summaryList'> Hours worked per week: <summaryBold> {hoursWorkedPerWeek} </summaryBold></p>",
					].join(''),
					Spanish: [
						"<p class='summaryList'> Salario por hora: <summaryBold> {hourlyRate} </summaryBold></p>",
						"<p class='summaryList'> Horas trabajadas por semana: <summaryBold> {hoursWorkedPerWeek} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Annual Salary
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'annualSalary',
							dataPathType: 'array',
						},
					],
					English: ["<p class='summaryList'> Annual Salary: <summaryBold> {annualSalary} </summaryBold></p>"].join(''),
					Spanish: ["<p class='summaryList'> Salario anual: <summaryBold> {annualSalary} </summaryBold></p>"].join(''),
				},
				//NOTE: Commisions or Bonuses
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'commissionsOrBonusesFrequency',
							dataPathType: 'array',
						},
					],
					English: [
						'<br> Commisions or Bonuses Income:',
						"<p class='summaryList'> Amount: <summaryBold> {commissionsOrBonusesAmount} {commissionsOrBonusesFrequency} </summaryBold></p>",
						"<p class='summaryList'> Description: <summaryBold> {commissionsOrBonusesDescription} </summaryBold></p>",
					].join(''),
					Spanish: [
						'<br> Ingresos de Comisiones o Bonos:',
						"<p class='summaryList'> Cantidad: <summaryBold> {commissionsOrBonusesAmount} {commissionsOrBonusesFrequency} </summaryBold></p>",
						"<p class='summaryList'> Descripción: <summaryBold> {commissionsOrBonusesDescription} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Pension
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'pensionFrequency',
							dataPathType: 'array',
						},
					],
					English: ['<br> Pension Income:', "<p class='summaryList'> Amount: <summaryBold> {pensionAmount} {pensionFrequency} </summaryBold></p>"].join(''),
					Spanish: [
						'<br> Ingresos de Pensiones:',
						"<p class='summaryList'> Cantidad: <summaryBold> {pensionAmount} {pensionFrequency} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Investment
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'investmentAmount',
							dataPathType: 'array',
						},
					],
					English: [
						'<br>Investment Income:',
						"<p class='summaryList'> Amount: <summaryBold> {investmentAmount} {investmentFrequency} </summaryBold></p>",
						"<p class='summaryList'> Description: <summaryBold> {investmentDescription} </summaryBold></p>",
					].join(''),
					Spanish: [
						'<br>Ingresos de Inversión:',
						"<p class='summaryList'> Cantidad: <summaryBold> {investmentAmount} {investmentFrequency} </summaryBold></p>",
						"<p class='summaryList'> Descripción: <summaryBold> {investmentDescription} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Other Income
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'otherIncomeAmount',
							dataPathType: 'array',
						},
					],
					English: [
						'<br> Other Income:',
						"<p class='summaryList'> Amount: <summaryBold> {otherIncomeAmount} {otherIncomeFrequency} </summaryBold></p>",
						"<p class='summaryList'> Description: <summaryBold> {otherIncomeDescription} </summaryBold></p>",
					].join(''),
					Spanish: [
						'<br> Otros ingresos:',
						"<p class='summaryList'> Cantidad: <summaryBold> {otherIncomeAmount} {otherIncomeFrequency} </summaryBold></p>",
						"<p class='summaryList'> Descripción: <summaryBold> {otherIncomeDescription} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Previous Employment (Military)
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'provideMilitaryPreviousEmployerName',
							dataPathType: 'array',
						},
					],
					English: [
						'</br> Previous Employment:',
						"<p class='summaryList'> Position: <summaryBold> {provideMilitaryPreviousEmployerPosition} </summaryBold></p>",
						"<p class='summaryList'> Employer: <summaryBold> {provideMilitaryPreviousEmployerName} </summaryBold></p>",
						"<p class='summaryList'> Start Date: <summaryBold> {provideMilitaryPreviousEmployerStartedDate} </summaryBold></p>",
						"<p class='summaryList'> Employer Phone: <summaryBold> {provideMilitaryPreviousEmployerPhoneNumber} </summaryBold></p>",
					].join(''),
					Spanish: [
						'</br> Empleo Anterior:',
						"<p class='summaryList'> Posición: <summaryBold> {provideMilitaryPreviousEmployerPosition} </summaryBold></p>",
						"<p class='summaryList'> Empleador: <summaryBold> {provideMilitaryPreviousEmployerName} </summaryBold></p>",
						"<p class='summaryList'> Fecha de inicio: <summaryBold> {provideMilitaryPreviousEmployerStartedDate} </summaryBold></p>",
						"<p class='summaryList'> Teléfono del Empleador: <summaryBold> {provideMilitaryPreviousEmployerPhoneNumber} </summaryBold></p>",
					].join(''),
				},
				//NOTE: Previous Employment (Non-Military)
				{
					conditionToShow: [
						{
							dataPath: 'quoteAppData.pathFollowed',
							comparisonType: 'equal',
							value: 'providePreviousEmployerName',
							dataPathType: 'array',
						},
					],
					English: [
						'</br> Previous Employment:',
						"<p class='summaryList'> Position: <summaryBold> {providePreviousEmployerPosition} </summaryBold></p>",
						"<p class='summaryList'> Employer Name: <summaryBold> {providePreviousEmployerName} </summaryBold></p>",
						"<p class='summaryList'> Start Date: <summaryBold> {providePreviousEmployerStartedDate} </summaryBold></p>",
						"<p class='summaryList'> Employer Phone: <summaryBold> {providePreviousEmployerPhoneNumber} </summaryBold></p>",
					].join(''),
					Spanish: [
						'</br> Empleo Anterior:',
						"<p class='summaryList'> Posición: <summaryBold> {providePreviousEmployerPosition} </summaryBold></p>",
						"<p class='summaryList'> Nombre del Empleador: <summaryBold> {providePreviousEmployerName} </summaryBold></p>",
						"<p class='summaryList'> Fecha de inicio: <summaryBold> {providePreviousEmployerStartedDate} </summaryBold></p>",
						"<p class='summaryList'> Teléfono del empleador: <summaryBold> {providePreviousEmployerPhoneNumber} </summaryBold></p>",
					].join(''),
				},
			],
			answerButtons: [
				{
					label: 'yesSummary',
					actions: [
						//{ //Plaid code
						//    action: 4,
						//    apiMethod: 'findPlaidCustomerRecord'
						//},
						{
							action: 2,
							nextQuestion: 'thankYouMessageCompleted',
							conditions: [
								//{ //Plaid code
								//    conditionList: [
								//        {
								//            dataPath: 'plaidId',
								//            comparisonType: 'equal',
								//            value: null,
								//        },
								//    ],
								//    goTo: 'wantPlaidVerification',
								//},
								{
									conditionList: [
										{
											dataPath: 'dateCompleted',
											comparisonType: 'different',
											value: null,
										},
									],
									goTo: 'applicationUpdatedCreditAppSummary2',
								},
							],
						},
						{
							action: 5,
						},
					],
					style: {
						background: 'successButtonColor',
						text: 'successButtonTextColor',
					},
				},
				{
					label: 'noSummary',
					actions: [
						{
							action: 2,
							nextQuestion: 'currentlyEmployed',
						},
					],
					style: {
						background: 'errorButtonColor',
						text: 'errorButtonTextColor',
					},
				},
			],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: true,
		},

		////Plaid Question
		//{ //Plaid code
		//    key: 'wantPlaidVerification',
		//    category: 'creditApp',
		//    type: 'QuestionPlaidLink',
		//    isEndOfApp: true,
		//    summaryDisplay: false,
		//    textsToShow: [
		//        {
		//            conditionToShow: null,
		//            English: "Almost there! To protect against fraud and ensure your identity is secure, we kindly ask you to take a photo of your driver's license. This step helps us confirm your identity and speed up the application process. It's just like showing your ID, but in a digital format. Rest assured, your information is securely stored and only used for the purpose of this application.",
		//            Spanish: "Casi hemos terminado! Para proteger contra el fraude y asegurar que su identidad esté segura, le pedimos amablemente que tome una foto de su licencia de conducir. Este paso nos ayuda a confirmar su identidad y acelerar el proceso de la solicitud. Es como mostrar su identificación, pero en formato digital. Tenga la seguridad de que su información se almacena de manera segura y solo se utiliza para el propósito de esta solicitud."
		//        },
		//    ],
		//    answerButtons: [
		//        //{
		//        //    label: 'procedeWithoutPlaidLink',
		//        //    actions: [
		//        //        {
		//        //            action: 2,
		//        //            nextQuestion: 'thankYouMessageCompleted',
		//        //        }
		//        //    ],
		//        //    style: {
		//        //        background: 'successButtonColor',
		//        //        text: 'successButtonTextColor'
		//        //    }
		//        //},
		//        {
		//            label: 'continue',
		//            isValidationRequired: true,
		//            actions: [
		//                {
		//                    action: 4,
		//                    apiMethod: 'plaidInfo'
		//                },
		//                {
		//                    action: 2,
		//                    nextQuestion: 'thankYouMessageCompleted',
		//                    conditions: [
		//                        {
		//                            conditionList: [
		//                                {
		//                                    dataPath: 'dateCompleted',
		//                                    comparisonType: 'different',
		//                                    value: null,
		//                                },
		//                            ],
		//                            goTo: 'applicationUpdatedCreditAppSummary2',
		//                        },
		//                    ]
		//                }
		//            ],
		//            style: {
		//                background: 'successButtonColor',
		//                text: 'successButtonTextColor'
		//            }
		//        }
		//    ],
		//    savedAnswer: null,
		//    dataStructurePath: '',
		//    prevQuestion: true,
		//},
		{
			key: 'thankYouMessage',
			category: 'thankYou',
			type: 'QuestionTextMessage',
			isEndOfApp: true,
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Thank you for providing your basic information!',
					Spanish: '¡Gracias por proveer su información básica!',
				},
			],
			notesToShow: [
				{
					conditionToShow: null,
					English: 'Please wait while we redirect you to your portal.',
					Spanish: 'Por favor espere mientras se le transfiere a su portal.',
				},
			],
			answerButtons: [],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: false,
			redirectToCustomerPortal: true,
		},
		{
			key: 'thankYouMessageCompleted',
			category: 'creditApp',
			type: 'QuestionTextMessage',
			isEndOfApp: true,
			isCompleted: true,
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Congratulations! </br>Your application has been completed.',
					Spanish: '¡Felicidades! </br>Tu solicitud ha sido completada.',
				},
			],
			answerButtons: [],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: false,
			redirectToCustomerPortal: true,
		},
		{
			key: 'applicationUpdated',
			category: 'thankYou',
			type: 'QuestionTextMessage',
			isEndOfApp: true,
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Your application has been successfully updated.',
					Spanish: 'Su applicacion ha sido actualizada exitosamente.',
				},
			],
			answerButtons: [],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: false,
			redirectToCustomerPortal: true,
		},
		{
			key: 'applicationUpdatedPersonal',
			category: 'personal',
			type: 'QuestionTextMessage',
			isEndOfApp: true,
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Your application has been successfully updated.',
					Spanish: 'Su applicacion ha sido actualizada exitosamente.',
				},
			],
			answerButtons: [],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: false,
			redirectToCustomerPortal: true,
		},
		{
			key: 'applicationUpdatedCreditAppSummary1',
			category: 'creditApp',
			type: 'QuestionTextMessage',
			isEndOfApp: true,
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Your application has been successfully updated.',
					Spanish: 'Su applicacion ha sido actualizada exitosamente.',
				},
			],
			answerButtons: [],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: false,
			redirectToCustomerPortal: true,
		},
		{
			key: 'applicationUpdatedCreditAppSummary2',
			category: 'creditApp',
			type: 'QuestionTextMessage',
			isEndOfApp: true,
			summaryDisplay: false,
			textsToShow: [
				{
					conditionToShow: null,
					English: 'Your application has been successfully updated.',
					Spanish: 'Su applicacion ha sido actualizada exitosamente.',
				},
			],
			answerButtons: [],
			savedAnswer: null,
			dataStructurePath: '',
			prevQuestion: false,
			redirectToCustomerPortal: true,
		},
	],
	theme: {
		mainTextColor: '#333',
		linkMainTextColor: '#005bff',
		altTextColor: '#fff',
		linkAltTextColor: '#00c2ec',
		lightMainTextColor: '#a7a7a7',
		secondaryTextColor: '#757575',
		linkSecondaryTextColor: '#3d8691',
		mainColor: '#61CC98',
		secondaryColor: '#ffffff',
		successButtonColor: '#61CC98',
		successButtonTextColor: '#ffffff',
		errorButtonColor: '#e16149',
		errorButtonTextColor: '#ffffff',
		categoryText: '#ffffff',
		categoryBulletBorderColor: '#ffffff',
		categoryBulletBackground: '0',
		categoryActiveText: '#ffffff',
		categoryActiveBulletBorderColor: '#ffffff',
		categoryActiveBulletBackground: '#ffffff',
		categorySuccessText: '#ffffff',
		categorySuccessBulletBorderColor: '#ffffff',
		categorySuccessBulletBackground: '#ffffff',
		optionsButtonColor: '#333',
		optionsButtonTextColor: '#ffffff',
		errorInputAccentColor: '#c11b1b',
		loginNoteBackground: '0',
		loginNoteTextColor: '#757575',
		appBackgroundColor: '#ecf2f9',
		primaryButtonColor: '#61CC98',
		secondaryButtonColor: '#e16149',
		tertiaryButtonColor: '#ceddfd',
	},
	prefilledReplacements: [
		{
			key: 'namePrefilled',
			prefilledPropertyName: 'firstName',
			useQuestionKey: 'isFirstNameCorrect',
			nextQuestionKey: 'provideFirstName',
		},
		{
			key: 'lastnamePrefilled',
			prefilledPropertyName: 'lastName',
			useQuestionKey: 'isLastNameCorrect',
			nextQuestionKey: 'provideLastName',
		},
		{
			key: 'dateOfBirthPrefilled',
			type: 'date',
			prefilledPropertyName: 'dateOfBirth',
			useQuestionKey: 'isDateOfBirthCorrect',
			nextQuestionKey: 'provideDateOfBirth',
		},
		{
			key: 'emailPrefilled',
			prefilledPropertyName: 'emailAddress',
			useQuestionKey: 'isEmailCorrect',
			nextQuestionKey: 'provideEmail',
		},
	],
	storeInfo: [
		{
			key: 'storeName',
			prefilledPropertyName: 'storeName',
		},
		{
			key: 'storePhone',
			prefilledPropertyName: 'storePhone',
		},
	],
	//localization: localization
});

export default ApplicationsSettings;
